/* eslint-disable no-template-curly-in-string */

export const language_en = {
  ft1_access: {
    accord_title: "Fleet Track 1.0 Access",
    account_label: "After a user registers in Fleet Track 2.0",
    account_option_allow: "Allow Fleet Track 1.0 login too",
    account_option_block: "Block Fleet Track 1.0 login",
    account_help:
      "Applies to users who have already registered in Fleet Track 2.0 as well as future registrations. Individual users can be overridden on their user page.",
    user_label: "Fleet Track 1.0 login",
    user_option_account: "Follow account setting",
    user_option_allow: "Always allow",
    user_option_block: "Always block",
    user_status_blocked: "Currently blocked from Fleet Track 1.0",
    user_status_allowed: "Currently allowed in Fleet Track 1.0",
    toast_saved: "Fleet Track 1.0 access updated.",
    toast_saved_counts:
      "Fleet Track 1.0 access updated ({{blocked}} users blocked, {{unblocked}} unblocked).",
    toast_failed: "Could not update Fleet Track 1.0 access.",
  },
  email_address: "Email address",
  email_address_placeholder: "Enter email address",
  password: "Password",
  password_placeholder: "Enter your password",
  login: "Login",
  login_as: "Login as...",
  forgot_your_password: "Forgot your password?",
  landingScreen: {
    heading: "Navigate Efficiency, Control, and Safety with Fleet Track.",
    content:
      "Fleet Track is a fleet management solution that monitors asset locations in real-time, analyses fuel consumption patterns, and ensures safety compliance. With customisable reporting features and intuitive interfaces, Fleet Track provides visibility and control over your fleet, allowing you to streamline performance, enhance efficiency, and reduce costs. Make informed decisions and transform your fleet management experience with Fleet Track today.",
  },
  loginScreen: {
    or: "Or",
    or_enter_password_below: "enter password below to login",
    login_company_portal: "Login with Company Portal",
    toast: {
      authentication_failed:
        "Authentication failed. Please check your email and password.",
      session_expired_logging_out:
        "You session has expired. You are being redirected to the login page...",
      session_expired: "Your session has expired. Please log in again.",
      logging_you_in: "Logging you in...",
      check_email_for_code:
        "Please check your email for the verification code.",
      check_email_phone_for_code:
        "Please check your email/phone for the verification code.",
      login_failed: "Login failed. Please check your email and password.",
      login_failed_unknown:
        "Login failed due to an unknown error. Please try again.",
      login_success: "Login successful. Welcome to FleetTrack!",
      custom_env_set: "Custom environment has been set. Please login.",
      custom_env_cleared: "Custom environment has been cleared.",
    },
  },
  authenticateScreen: {
    heading: "Authenticating...",
    sub_heading: "Please wait while we authenticate you.",
    back_to_home: "Back to Home",
    toast: {
      authentication_failed:
        "Authentication failed. Please make sure that you are using the correct link.",
      check_email_for_code:
        "Please check your email for the verification code.",
      login_failed:
        "Login failed. Please make sure that you are using the correct link.",
      login_failed_unknown:
        "Login failed due to an unknown error. Please try again.",
      login_success: "Login successful. Welcome to FleetTrack!",
    },
  },
  authAzureCallbackScreen: {
    heading: "Authenticating...",
    sub_heading: "Please wait while we authenticate you.",
  },
  forgotPasswordScreen: {
    heading: "Forgot your password?",
    sub_heading:
      "Please enter your email address below and we will send you a 6-digit code to help you reset your password",
    submit_button: "Send Reset Code",
    toast: {
      sending_reset_code: "Sending reset code...",
      reset_code_sent:
        "A reset code has been sent to the provided email if it is registered.",
      reset_code_failed: "Failed to send reset code. Please check your email.",
    },
  },
  select_groups_button: "Select Groups",
  confirm: "Confirm",
  submit: "Submit",
  cancel: "Cancel",
  close: "Close",
  prev: "Prev",
  next: "Next",
  mute: "Mute",
  unmute: "Unmute",
  hangup: "Hang Up",
  answer: "Answer",
  decline: "Decline",
  incomingcall: "Incoming call",
  connecting: "Connecting",
  resetPasswordScreen: {
    heading: "Reset Password",
    sub_heading_1:
      "We have sent a 6-digit code to your email. Please enter below the code that you have received.",
    sub_heading_2: "Please set up your new password below",
    verification_code: "Verification Code",
    verification_code_placeholder: "Please enter the code here to verify",
    new_password: "New Password",
    new_password_placeholder: "Enter your new password",
    confirm_new_password: "Confirm New Password",
    confirm_new_password_placeholder: "Re-enter your new password",
    submit_button: "Reset Password",
    toast: {
      verifying_code: "Verifying code...",
      code_verified:
        "Your password has been changed. Please log in with your new password.",
      code_verification_failed:
        "Code verification failed. Please check the code that you have entered.",
    },
  },
  select2FAMethodScreen: {
    heading: "Verification",
    sub_heading: "Please select the mode of verification",

    via_mobile: "Via Mobile SMS",
    via_email: "Via Email Code",
    submit_button: "Proceed",

    toast: {
      code_sent_mobile: "We have sent you the code on your mobile.",
      code_sent_email: "We have sent you the code on your email.",
    },
  },
  verify2FAEmail: {
    heading: "Verification - Email",
    sub_heading_1: "We have sent a verification code on your email address", // {{email}}
    sub_heading_2: "Please type in the code below to proceed.",
    verification_code: "Verification Code",
    verification_code_placeholder: "Please enter the code here to verify",
    submit_button: "Verify and Sign In",
    code_not_received: "Did not receive the code?",
    resend_code: "Resend Code",
    toast: {
      no_email: "We could not verify your email address. Please login again.",
      resending_code: "Resending code...",
      code_sent: "We have sent you the code on your email.",
      code_send_failed: "Failed to send the code. Please try again.",
      verifying_code: "Verifying code...",
      code_verified: "You have been verified. Welcome to FleetTrack!",
      code_verification_failed:
        "Code verification failed. Please check the code that you have entered.",
      code_invalid:
        "The code you have entered is invalid. Please check the code that you have entered.",
    },
  },
  verify2FAMobile: {
    heading: "Verification - SMS",
    sub_heading_1:
      "We have sent a verification code to your registered mobile number.", // {{mobile}}
    sub_heading_2: "Please type in the code below to proceed.",
    verification_code: "Verification Code",
    verification_code_placeholder: "Please enter the code here to verify",
    submit_button: "Verify and Sign In",
    code_not_received: "Did not receive the code?",
    resend_code: "Resend Code",
    toast: {
      no_mobile: "We could not verify your mobile. Please login again.",
      resending_code: "Resending code...",
      code_sent: "We have sent you the code on your mobile.",
      code_send_failed: "Failed to send the code. Please try again.",
      verifying_code: "Verifying code...",
      code_verified: "You have been verified. Welcome to FleetTrack!",
      code_verification_failed:
        "Code verification failed. Please check the code that you have entered.",
      code_invalid:
        "The code you have entered is invalid. Please check the code that you have entered.",
    },
  },
  accountSetupScreen: {
    heading: "Account Setup",
    sub_heading:
      "Please verify your information & setup up a new password to proceed",
    name: "Name",
    email: "Email",
    organization_name: "Organization Name",
    role: "Role",
    new_password: "New Password",
    new_password_placeholder: "Enter your new password",
    confirm_new_password: "Confirm New Password",
    confirm_new_password_placeholder: "Re-enter your new password",
    submit_button: "Update & Proceed",
    toast: {
      onboarded:
        "You have successfully setup your account. Please login with your new password.",
      onboarding_failed:
        "Failed to setup your account. Please check the information that you have entered.",
    },
  },
  toast: {
    general_error:
      "An unexpected error has occurred. If this happens again, please report the issue to your administrator. We regret the inconvenience.",
  },
  notification_prefs: {
    toast: {
      update_failed: "Failed to update notification preferences.",
      updated: "Notification preferences updated.",
    },
  },
  changePasswordScreen: {
    heading: "Update Password",
    sub_heading_1: "Please enter your current password below",
    sub_heading_2: "Please set up your new password below",
    current_password: "Current Password",
    current_password_placeholder: "Enter your current password",
    new_password: "New Password",
    new_password_placeholder: "Enter your new password",
    confirm_new_password: "Confirm New Password",
    confirm_new_password_placeholder: "Re-enter your new password",
    submit_button: "Change Password",
    toast: {
      password_changed: "Your password has been changed.",
      password_change_failed:
        "Your password could not be changed. Please check the information that you have entered.",
    },
  },
  accessControl: {
    toast: {
      access_denied: "You do not have access to the {{page}} page.", // TODO: not in use yet
    },
  },
  dashboard: {
    sidemenu: {
      dashboard: "Dashboard",
      maps: "Map Overview",
      fleet: "Fleet Map",
      asset: "Asset Map",
      heat: "Heat Map",
      multiVehicle: "Multi-Vehicle Map",
      managed_accounts: "Managed Accounts",
      reports: "Reports",
      incident_review:"Incident Review",
      manage_roles: "Manage Roles",
      maintenance_admin: "Maintenance",
      group_admin: "Group Admin",
      administrators: "Administrators",
      administration: "Administration",
      // manage_rule_alert: "Manage Rule/Alert",
      asset_alert: "Asset Alert",
      panic_alert: "Panic Alert",
      camera_admin: "Cameras",
      crash_track: "Crash Reconstruction",
      compliance_admin: "Compliance",
      main_menu: "Main Menu",
      whitelabel_settings: "White label settings",
      admins: {
        users: "Users",
        roles: "Roles",
        manage_rule_alert: "Rules/Alerts",
        assets: "Assets",
        groups: "Groups",
        fleettags: "FleetTags",
        drivers: "Drivers",
        geozones: "Geozones",
        geozone_categories: "Geozone Categories",
        maintenance: "Maintenance",
        documents: "Documents",
        importExport: "Import/Export",
        heatMap: "Heat Map",
        incident_config: "Incident Config",
        incabcoaching: "In-Cab Coaching",
        event_colors: "Event Colors",
      },
      sysadmin: {
        enterprises: "Enterprise Onboarding",
      },
    },
    notifications: {
      heading: "Notifications",
      heading_alerts: "Alerts",
      view_all: "View All",
      no_notifications: "No notifications found",
      no_notifications_recent: "No notifications found in the last 30 days",
      no_alerts: "No alerts found",
      no_alerts_recent: "No alerts found in the last 30 days",
      filter_rule_description: "Select Rule Description",
      filter_rule_description_placeholder: "All Types",
      filter_date_from: "Date From",
      filter_date_to: "Date To",
      filter_all: "All",
      filter_read: "Read",
      filter_unread: "Unread",
      mark_as_read: "Mark as read",
      toast: {
        notification_marked_read: "Notification has been marked as read.",
        notification_marked_read_failed: "Failed to mark notification as read.",
        alert_marked_read: "Alert has been marked as read.",
        alert_marked_read_failed: "Failed to mark alert as read.",
      },
    },
    top: {
      admins: "Admins",
      account: "Account",
      change_password: "Change Password",
      logout: "Logout",
      logout_impersonated: "Use 'Exit Access' button above to logout",
      help: "Help",
      messaging: "Chat/SMS",
      alerts: "Alerts",
      notifications: "Notifications",
      notification_prefs: "Notification Preferences",
      goto_ft_1_0: "Go to FleetTrack 1.0",
      redirect_ft_1_0_not_allowed: "Redirect to FleetTrack 1.0 is not allowed.",
      user_account: "Account",
    },
    profile: {
      account: {
        heading: "Account Information",
        sub_heading: "Edit Account Information",
        accord_general_details: "General Details",
        accord_maintenance_interval_labels: "Maintenance Interval Labels",
        accord_scorecard_weight_factors: "Scorecard Weight Factors",
        accord_asset_label_fields: "Asset Label & Search Settings",
        toast: {
          account_updated: "Account has been updated successfully.",
          updation_failed:
            "Failed to update account. Please check the information that you have entered.",
        },
        form: {
          account_id: "Account ID",
          account_description: "Account Description",
          contact_name: "Contact Name",
          contact_phone_number: "Contact Phone Number",
          contact_email: "Contact Email",
          private_cost: "Private Cost",
          idle_gas_usage: "Idle Gas Usage",
          distance_gas_usage: "Distance Gas Usage",
          auto_update_interval_for_maps: "Auto Update Interval for Maps",
          drivers_assigned_to_devices: "Drivers Assigned to Devices",
          enable_map_clustering: "Enable Map Clustering",
          open_reports_in_new_tab: "Open Reports in New Tab",
          sync_driverId_from_driver_admin: "Sync Driver ID from Driver Admin",
          has_snowplows: "Has Snowplows",
          hide_total_rows_in_csv: "Hide Total Rows in CSV",
          timezone: "Timezone",
          speed_units: "Speed Units",
          distance_units: "Distance Units",
          volume_units: "Volume Units",
          economy_units: "Economy Units",
          pressure_units: "Pressure Units",
          temperature_units: "Temperature Units",
          minidleseconds: "Minimum Idle Threshold (Minutes)",
          cameraliveviewduration: "Camera Live View Duration",
          latitude_longitude_format: "Latitude Longitude Format",
          route_segment_color_rule: "Route Segment Color Rule",
          route_line_thickness: "Route Line Thickness",
          multi_vehicle_map_name: "Multi Asset Map Name",
          device_title: "Device Title",
          device_title_plural: "Plural",
          device_group_title: "Group Title",
          device_group_title_plural: "Plural",
          address_title: "Address Title",
          address_title_plural: "Plural",
          default_login_userId: "Default Login User ID",
          default_overlay: "Default Overlay",
          map_icon_size: "Map Icon Size",
          last_maintenance_1: "Last Maintenance #1",
          last_maintenance_2: "Last Maintenance #2",
          last_maintenance_3: "Last Maintenance #3",
          last_maintenance_4: "Last Maintenance #4",
          last_maintenance_5: "Last Maintenance #5",
          last_maintenance_6: "Last Maintenance #6",
          last_maintenance_7: "Last Maintenance #7",
          last_maintenance_8: "Last Maintenance #8",
          last_maintenance_9: "Last Maintenance #9",
          last_maintenance_10: "Last Maintenance #10",
          last_eng_hours_maint_1: "Last Eng Hours Maint #1",
          last_eng_hours_maint_2: "Last Eng Hours Maint #2",
          last_eng_hours_maint_3: "Last Eng Hours Maint #3",
          last_eng_hours_maint_4: "Last Eng Hours Maint #4",
          last_eng_hours_maint_5: "Last Eng Hours Maint #5",
          last_service_time_1: "Last Service Time #1",
          last_service_time_2: "Last Service Time #2",
          last_service_time_3: "Last Service Time #3",
          last_service_time_4: "Last Service Time #4",
          last_service_time_5: "Last Service Time #5",
          harsh_braking: "Harsh Braking",
          harsh_acceleration: "Harsh Acceleration",
          speeding: "Speeding",
          reverse: "Reverse",
          seatbelt_off: "Seatbelt Off",
          harsh_cornering: "Harsh Cornering",
          idle_ratio: "Idle Ratio",
          impact_crash_ai: "Posible Impact",
          cellphone_use_ai: "Cellphone Usage",
          distracted_driving_ai: "Distracted Driving",
          drinking_eating_ai: "Drinking/Eating",
          smoking_ai: "Smoking",
          possible_fatiuge_ai: "Driver Fatigue",
          obstructed_camera_ai: "Obstructed Camera",
          tailgating_ai: "Tailgating",
          scorewtfrontcollisionai: "Front Collision Warning",
          scorewtpedestriancollisionai: "Pedestrian Detection",
          scorewtlanedepartureai: "Lane Departure Warning",
          scorewtstopandgoai: "Stop-and-Go Traffic Detection",
          scorewtrollingstopai: "Rolling Stop Detection",
          scorewtcamerapowerlossai: "Power Loss",
          scorewtcameracoverremovalai: "Cover Removal",
          scorewt75for30ai: "75 for 30",
          use_2fa: "Use Two factor",
          toggleft: "Toggle FT",
          map_infobox_information: "Map Infobox Information",
          infobox_always_open: "Map Infobox Always Open",
          hide_asset_map_pinpoints: "Hide Asset Map Pinpoints",
          asset_label_fields: "Label Display Fields",
          asset_searchable_fields: "Searchable Fields",
        },
      },
    },
  },
  buzzerAlert: {
    status_1: "Pending", // generally not used
    status_2: "In Progress",
    single: {
      heading: "Alert",
      asset: "Asset",
      location: "Location",
      latlng: "Lat Long",
      button_view_alert: "View Alert",
    },
    list: {
      heading: "Alert",
      total_alerts: "Total Alerts: {{count}}",
      asset: "Asset",
      location: "Location",
      latlng: "Lat Long",
      button_view_alerts: "View Alerts",
    },
  },
  type_here_to_search: "Type here to search...",
  group_toggle_label_off: "Assets",
  group_toggle_label_on: "Groups",
  group_camera_toggle_label_off: "Cameras",
  group_camera_toggle_label_on: "Groups",
  search_groups: "Search groups...",
  search_assets: "Search assets...",
  search_cameras: "Search cameras...",
  pagination: {
    number_of_items: "Number of items",
    showing_x_to_y_of_z_records:
      "Showing {{start}} to {{end}} of {{total}} records",
  },
  no_items_found: "No items found",
  loading_items: "Loading items...",
  filter_applied: "Filter applied",
  overviewScreen: {
    heading: "Dashboard",
    filter_groups: "Groups/Assets",
    add_remove_widgets: "Add/Remove Widgets",
    done: "Done",
    add_dashboard: "Add Dashboard",
    no_dashboard: "Create a Dashboard",
    no_dashboard_subtitle:
      "You have not created any dashboards yet. Click below to create a new dashboard.",
    no_widget_on_dashboard: "Add your first widget",
    no_widget_on_dashboard_subtitle:
      "You have not added any widgets to this dashboard yet. Click below to add a new widget.",
    add_a_widget: "Add a Widget",
    top_10_in_efficiency: "Top 10 in Efficiency", // temporary
    highest_ratio_10: "Highest Ratio (10)", // temporary
    create_new: {
      heading: "Add Dashboard",
      heading_edit: "Edit Dashboard",
      dashboard_name: "Dashboard Name",
      dashboard_name_placeholder: "Please provide a dashboard name",
      submit_button: "Create Dashboard",
      update_button: "Update Dashboard",
      toast: {
        create_failed:
          "Failed to create dashboard. Please check the information that you have entered.",
        create_success: "Dashboard has been created successfully.",
        update_failed:
          "Failed to update dashboard. Please check the information that you have entered.",
        update_success: "Dashboard has been updated successfully.",
      },
    },
    add_widgets: {
      heading: "Add Widgets",
      add: "Add",
      edit: "Edit",
      remove: "Remove",
      category_safety: "Safety",
      category_fuel: "Fuel & Energy",
      category_maintenance: "Maintenance",
      section_standard: "Standard",
      section_custom: "Custom",
      custom: {
        use_report: "Use Custom Report",
        select_report: "Select Report",
        my_report: "My Custom Reports",
        shared: "Shared with me",
        custom_widgets: "Custom Widgets",
        cannot_select_report:
          "This report does not make use of grouping and aggregation and thus cannot be selected for custom widget.",
      },
      toast: {
        dashboard_not_selected: "Please select a dashboard to add widgets.",
        custom_widget_not_found: "The custom widget could not be found",
        custom_widget_report_not_found:
          "The report associated with the custom widget was not found",
        add_failed: "Failed to add widget.",
        add_success: "Widget have been added successfully.",
        remove_success: "Widget has been removed successfully.",
      },
      no_widgets: "No more widgets available.",
      reference_data: "Representative Data",
      no_reports: "No reports found",
    },
    widget_titles: {
      view_details: "View Details",
      remove: "Remove",
      close_print_mode: "Close Print Mode",
      view_all_as_report: "View All as Report",
      safety_events: "Safety Events",
      // FLEET_FUEL_SUMMARY: "Fleet Fuel Summary",
      // ASSET_EVENTS: "Asset Events",
      // MAINTENANCE_OVERDUE: "Maintenance Overdue",
      // ASSET_STATUS_REPORT: "Asset Status Report",
      enum_1: "Maintenance Upcoming & Overdue",
      enum_2: "Maintenance Upcoming & Overdue (Engine Hours)",
      enum_3: "Maintenance Upcoming & Overdue (Time)",
      enum_4: "Maintenance Overdue",
      enum_5: "Asset Status - Report",
      enum_6: "Asset Health",
      enum_7: "Safety Events",
      enum_8: "Asset Safety Events",
      enum_9: "Driver Performance",
      enum_10: "Fleet Fuel Summary",
      enum_11: "Fuel Efficiency",
      // enum_12: "Driver Fuel Efficiency",
      enum_13: "Idling Ratio",
      // enum_14: "Driver Idling Ratio",
      enum_15: "Fuel/Energy Consumption Trends",
      enum_16: "Vehicle Efficiency Comparisons",
      enum_17: "Key Performance Indicators",
    },
    no_widget_data: "No data found for this widget.",
    widgets: {
      enum_1: {
        filter_label_sorting_desc: "Top 10 Upcoming/Timely",
        filter_label_sorting_asc: "Top 10 Overdue",
      },
      enum_2: {
        filter_label_sorting_desc: "Top 10 Upcoming/Timely",
        filter_label_sorting_asc: "Top 10 Overdue",
      },
      enum_3: {
        filter_label_sorting_desc: "Top 10 Upcoming/Timely",
        filter_label_sorting_asc: "Top 10 Overdue",
      },
      enum_4: {
        total_assets_in_fleet: "Total Assets in Fleet",
        label_total_score: "Total Safety Event Score",
        label_total_count: "Total Safety Event Count",
        filter_label: "Highest Events (10)", // temporary
        overdue_miles: "Overdue by Miles",
        overdue_hours: "Overdue by Engine Hours",
        overdue_period: "Overdue by Period",
      },
      enum_5: {
        fleet_wise_breakup: "Fleet Breakdown",
        total_count: "Total Count",
        ignition_off: "Ignition Off",
        driving: "Driving",
        idle: "Idle",
      },
      enum_6: {
        fleet_wise_breakup: "Fleet Breakdown",
        total_count: "Total Count",
        timestamp_zero_count: "Never Reported",
        within_last_24_hours_count: "Reported in last 24h",
        more_than_24_hours_count: "Not reported in last 24h",
        under_maintenance: "Under Maintenance",
      },
      enum_8: {
        filter_label_sorting_desc: "Top Performing (10)",
        filter_label_sorting_asc: "Low Performing (10)",
      },
      enum_9: {
        filter_label_sorting_desc: "Top Performers (10)",
        filter_label_sorting_asc: "Low Performers (10)",
      },
      enum_10: {
        filter_label: "Break-up",
        fleet_driving_hours: "Fleet Driving Hours",
        fleet_idle_hours: "Fleet Idle Hours",
        fleet_engine_hours: "Fleet Engine Hours",
        total_fuel_cost: "Total Fuel Cost",
        fleet_driving_cost: "Fleet Driving Cost",
        fleet_idling_cost: "Fleet Idling Cost",
      },
      enum_11: {
        filter_label_sorting_desc: "Most Effecient (10)",
        filter_label_sorting_asc: "Least Efficient (10)",
      },
      enum_12: {
        filter_label_sorting_desc: "Most Effecient (10)",
        filter_label_sorting_asc: "Least Efficient (10)",
      },
      enum_13: {
        filter_label_sorting_desc: "Highest Ratio (10)",
        filter_label_sorting_asc: "Lowest Ratio (10)",
      },
      enum_14: {
        filter_label_sorting_desc: "Highest Ratio (10)",
        filter_label_sorting_asc: "Lowest Ratio (10)",
      },
      enum_17: {
        avg_energy_economy: "Average Energy Efficiency",
        avg_fuel_efficiency: "Average Fuel Efficiency",
        avg_trip_duration: "Average Trip Duration",
        avg_trip_distance: "Average Trip Distance",
        charging_sessions: "Charging Sessions",
        energy_recovered: "Energy Recovered (Regen)",
        idle_fuel_consumption: "Idle Fuel Consumption",
        total_energy_consumed: "Total Energy Consumed",
        total_fuel_consumed: "Total Fuel Consumed",
      },
    },
    manage_widgets: {
      toast: {
        delete_widget_failed: "Failed to delete custom widget",
        delete_widget_success: "The custom widget was deleted successfully",
      },
    },
    charts: {
      average_label: "Fleet Avg.",
    },
    switch_chart_type: {
      heading: "Select Graph Type",
      types: {
        PIE: "Pie",
        DOUGHNUT: "Doughnut",
        VERTICAL_BAR_GRAPH: "Vertical Bar Graph",
        HORIZONTAL_BAR_GRAPH: "Horizontal Bar Graph",
        STACKED_BAR_GRAPH: "Stacked Graph",
        LINE_GRAPH: "Line Graph",
      },
    },
    toast: {
      move_failed: "Failed to move widget.",
      move_success: "Widget has been moved successfully.",
      dashboard_delete_success: "Dashboard has been deleted successfully.",
    },
  },
  globalSearch: {
    REPORT: "Reports",
    dashboard: "Dashboard",
    administration: "Admins",
    help: "Help",
    searching: "Searching...",
    no_results_found: "No results found",
    HELP_ARTICLE: "Help",
  },
  admins: {
    refresh_data: "Refresh Data",
    completeCreation:
      "Please fill the form and click SAVE to complete the process",
    edit_columns: {
      show_hide_button_label: "Show/Hide Columns",
      sort_columns: "Sort Columns",
      heading: "Edit Columns",
      sub_heading:
        "Edit the selection of your columns. See the information that is most relevant to your business",
      submit_button: "Save & Close",
    },
    filters: {
      active: "Active",
      inactive: "Inactive",
      both: "Both",
    },
    delete_confirmation: {
      heading: "Delete",
      sub_heading: "Are you sure you want to delete?",
      sub_heading_image: "Are you sure you want to delete the image?",
    },
    reset_confirmation: {
      heading: "Reset",
      sub_heading: "Are you sure you want to reset?",
    },
    sorted_by: "Sorted by {{column}}",
    reset_sorting: "Reset sorting",
    users: {
      heading: "Users",
      sub_heading:
        "Create users and delete users in the system to view maps and asset information",
      add_new: "Add New User",
      listing_heading: "User Listing",
      search_placeholder: "Search users here...",
      resend_invite_button: "Resend Invite",
      login_as_button: "Login As",
      resend_invite_button_email_error:
        "Invitation can be sent once the user's email address is set.",
      resend_invite: {
        toast: {
          success: "The invitation was sent successfully.",
          failed: "The invitation was not sent.",
        },
      },
      create_new: {
        heading: "Add New User",
        sub_heading:
          "Please provide the information below to create a New User",
        user_id: "User ID",
        user_name_placeholder: "Please enter the username",
        email_address: "Email ID",
        email_address_placeholder: "Please provide an email address",
        acl_role: "Default ACL Role",
        acl_role_placeholder: "Please select a role",
        submit_button: "Create New User & Send Invite",
        bottom_text_1: "Did not find a suitable role?",
        bottom_text_click_here: "Click Here",
        bottom_text_2: "to create new ACL Role",
        toast: {
          create_failed:
            "Failed to create user. Please check the information that you have entered.",
          create_success:
            "User has been created successfully. An email has been sent to the user with a link to setup their account.",
        },
      },
      detailsPage: {
        heading: "Specific User View",
        sub_heading:
          "Create Users and delete users in the system to view maps and asset information",
        listing_heading: "Users",
        accord_general_details: "General Details",
        accord_authorized_groups: "Authorized Groups",
        accord_user_access_control: "User Access Control",
        select_group_to_add: "Select a group to add",
        select_group_to_add_placeholder: "Select a group",
        group_selector_no_options: "No groups found. Type to search...",
        role: "Role",
        maximum_access_level: "Maximum Access Level",
        toast: {
          user_not_found: "The requested user was not found.",
          user_updated: "User has been updated successfully.",
          user_deleted: "User has been deleted successfully.",
          updation_failed:
            "Failed to update user. Please check the information that you have entered.",
          deletion_failed: "Failed to delete user.",
        },
        form: {
          reset_default: "Reset to Default",
        },
      },
    },
    roles: {
      heading: "Roles",
      sub_heading: "Create roles and assign permissions to users",
      add_new: "Add New Role",
      listing_heading: "Role Listing",
      search_placeholder: "Search roles here...",
      create_new: {
        heading: "Add New Role",
        sub_heading:
          "Please provide the information below to create a New Role",
        role_id: "Role Title",
        role_id_placeholder: "Please provide a role title",
        description: "Description",
        description_placeholder: "Please provide a description for the role",
        submit_button: "Create New Role",
        toast: {
          create_failed:
            "Failed to create role. Please check the information that you have entered.",
          create_success: "Role has been created successfully.",
          create_duplicate_failed:
            "The entered Role ID already exists. Please enter a different Role ID.",
        },
      },
      clone_to_new: {
        heading: 'Clone "{{original_role}}" to a New Role',
      },
      detailsPage: {
        heading: "Specific Role View",
        sub_heading: "Create roles and assign permissions to users",
        listing_heading: "Roles",
        accord_details: "Details",
        accord_role_access_control: "Role Access Control",
        accord_users: "Users ({{count}})",
        type_to_search_acl: "Type to search ACL...",
        n_user: "{{count}} user",
        n_users: "{{count}} users",
        toast: {
          role_has_users:
            "Role has users. Please move users to different role before deleting the role.",
          role_not_found: "The requested role was not found.",
          role_updated: "Role has been updated successfully.",
          role_deleted: "Role has been deleted successfully.",
          updation_failed:
            "Failed to update role. Please check the information that you have entered.",
          deletion_failed: "Failed to delete role.",
          role_acl_updated:
            "Role Access Control has been updated successfully.",
          role_acl_failed: "Failed to update role access control.",
        },
        form: {
          role_title: "Role Title",
          description: "Description",
          reset_default: "Reset to Default",
        },
        add_users: "Add Users to Role",
        no_users_found: "No users found.",
        no_role_acl_found: "No role access control found.",
        add_new_users_modal: {
          modal_heading: "Add Users to Role - “{{role}}”",
          sub_heading: "Please select the users you wish to add to the role",
          listing_heading: "User Listing",
          user_not_listed: "Users not in selected role",
          users_search_placeholder: "Search for users here...",
          users_selected: "Users to be assigned selected role",
          default_search_placeholder: "Search here...",
          save_button: "Save",
          move_user_from_role: "Click to confirm change in user role",
        },
      },
    },
    vehicles: {
      heading: "Assets",
      sub_heading: "Create assets and asset details for monitoring",
      add_new: "Add New Asset",
      listing_heading: "Asset Listing",
      search_placeholder: "Search assets here...",
      create_new: {
        heading: "Add New Asset",
        sub_heading:
          "Please provide the information below to create a New Asset",
        vehicle_id: "Asset ID",
        vehicle_id_placeholder: "Please provide the asset ID",
        make: "Asset Make",
        make_placeholder: "Please provide the asset make",
        model: "Asset Model",

        model_placeholder: "Please provide the year of the asset",
        vin: "VIN",
        vin_placeholder: "Please provide a valid VIN",
        license_plate: "License Plate",
        license_plate_placeholder: "Please provide a valid license plate",
        submit_button: "Create New Asset",
        toast: {
          create_failed:
            "Failed to create asset. Please check the information that you have entered.",
          create_success: "Asset has been created successfully.",
        },
      },
      detailsPage: {
        heading: "Specific Asset View",
        sub_heading: "Create assets and asset details for monitoring",
        listing_heading: "Assets",
        accord_details: "GPS Details",
        accord_recorder_info: "Camera Details",
        accord_zip_tie:"Serialized Zip Ties",
        accord_group_membership: "Group Membership",
        toast: {
          vehicle_not_found: "The requested vehicle was not found.",
          vehicle_updated: "Asset has been updated successfully.",
          vehicle_deleted: "Asset has been deleted successfully.",
          updation_failed:
            "Failed to update asset. Please check the information that you have entered.",
          deletion_failed: "Failed to delete asset.",
        },
        form: {
          icon_type: "Icon Type",
          no_icon: "No Icon",
          vehicle_id: "Asset ID",
          creation_date: "Creation Date",
          server_id: "Server ID",
          firmware_version: "Firmware Version",
          unique_id: "Unique ID",
          reported_odometer: "Reported Odometer",
          reported_hours: "Reported Engine Hours",
          odometer_offset: "Odometer Offset Value",
          engine_hours_offset: "Engine Hours Offset Value",
          odometer_sum: "Odometer (Reported + Offset)",
          hours_sum: "Engine Hours (Reported + Offset)",
          reset: "Reset",
          previous_unique_id: "Previous Unique ID",
          unique_id_last_changed: "Unique ID Last Changed",
          department_id: "Department ID",
          is_active: "Is Active",
          is_border_crossing: "Is Border Crossing",
          sparse_event_reporting: "Sparse Event Reporting",
          vehicle_description: "Asset Description",
          short_name: "Display Name",
          vin: "Manual VIN",
          vehicle_make: "Asset Make",
          vehicle_model: "Asset Model",
          vehicle_year: "Asset Year",
          license_plate: "License Plate",
          license_expiration: "License Expiration",
          equipment_type: "Asset VIN",
          equipment_status: "Equipment Status",
          asset_type: "Asset Type",
          vehicle_class: "Asset Class",
          imei_number: "IMEI/ESN Number",
          serial_number: "Serial Number",
          phone_number: "SIM Phone",
          email: "SMS Email Address",
          group_pushpin_id: "Group Pushpin ID",
          map_route_color: "Map Route Color",
          ignition_input: "Ignition Input",
          maximum_speed: "Maximum Permitted Speed Limit",
          driver_id: "Driver ID",
          driver_id_placeholder: "Type and select a driver...",
          driver_id_no_item: "No driver found. Type to search...",
          driver_name: "Driver Name",
          driver_phone_number: "Driver Phone",
          fuel_type: "Fuel Type",
          fuel_capacity: "Fuel Capacity",
          fuel_economy: "Fuel Economy",
          fuel_cost: "Fuel Cost",
          recorder_id: "Camera ID",
          recorder_on: "Camera",
          recorder_type: "Camera Type",
          previous_recorder_id: "Previous Camera ID",
          recorder_id_last_changed: "Camera ID Last Changed",
          zip_tie_form_title: "Manage serialized zip ties assigned to this asset",
          zip_tie_add_button: "+ Add Zip Tie",
          group_selector: "Select a group to add",
          group_selector_no_options: "No groups found. Type to search...",
          group_selector_placeholder: "Type to search groups...",
          camera_selector_placeholder: "Select camera id",
          camera_selector_no_options: "No cameras found.",
          all_groups: "All Groups",
          decode_vin: "Decode VIN",
          heading: "Decode VIN",
          sub_heading:
            "Please confirm the details to update the vehicle information.",
          confirm: "Confirm",
          make: "Make",
          model: "Model",
          year: "Model Year",
          update_asset: "Update Asset",
          upload: "Upload",
          upload_info: "Recommended image dimension: 800 x 600 pixels",
          no_image: "No image",
          last_timestamp: "Last Timestamp",
        },
      },
    },
    drivers: {
      heading: "Drivers",
      sub_heading: "Add and delete driver information",
      add_new: "Add New Driver",
      listing_heading: "Driver Listing",
      search_placeholder: "Search drivers here...",
      create_new: {
        heading: "Add New Driver",
        sub_heading:
          "Please provide the information below to create a New Driver",
        name: "Driver ID",
        name_placeholder: "Please provide the driver's ID",
        email: "Email ID",
        email_placeholder: "Please provide the driver's email address",
        phone: "Phone Number",
        phone_placeholder: "Please provide the driver's phone number",
        submit_button: "Create New Driver",
        toast: {
          create_failed:
            "Failed to create driver. Please check the information that you have entered.",
          create_success: "Driver has been created successfully.",
          create_duplicate_failed:
            "The entered Driver ID already exists. Please enter a different Driver ID.",
        },
      },
      detailsPage: {
        heading: "Specific Driver View",
        sub_heading: "Add and delete driver information",
        listing_heading: "Drivers",
        accord_details: "Details",
        accord_license_details: "License Details",
        accord_medical_and_other_details: "Medical and Other Details",
        toast: {
          driver_not_found: "The requested driver was not found.",
          driver_updated: "Driver has been updated successfully.",
          driver_deleted: "Driver has been deleted successfully.",
          updation_failed:
            "Failed to update driver. Please check the information that you have entered.",
          deletion_failed: "Failed to delete driver.",
        },
        form: {
          driver_id: "Driver ID",
          driver_name: "Driver Name",
          nick_name: "Nickname",
          contact_phone: "Contact Phone",
          contact_email: "Contact Email",
          badge_employee_id: "Employee ID",
          card_id: "Card ID",
          is_active: "Is Active",
          license_type: "License Type",
          license_state: "License State",
          license_number: "License Number",
          license_expiry_date: "License Expiration",
          license_status: "License Status",
          medical_card_no: "Medical Card No",
          medical_card_expiry_date: "Medical Card Expiration",
          hazmat_certified: "Hazmat Certified",
          twic: "Trans Worker ID cred (TWIC)",
          twic_expiry_date: "TWIC Expiration",
          address: "Address",
          vehicle_id: "Asset ID",
          upload: "Upload",
          upload_info: "Recommended image dimension: 800 x 600 pixels",
          no_image: "No image",
        },
      },
    },
    groups: {
      heading: "Groups",
      sub_heading: "Manage your groups",
      add_new: "Add New Group",
      listing_heading: "Group Listing",
      search_placeholder: "Search groups here...",
      hierarchy: {
        toast: {
          group_deleted: "Group has been deleted successfully.",
          deletion_failed: "Failed to delete group.",
        },
        parent_group: "Parent Group",
        viewing_group: "Selected Group",
        sub_group_level: "Sub-Group Level {{level}}",
        search_placeholder: "Search for a group here...",
        assets_count: "Assets: {{count}}",
        load_more: "Load More",
        add_parent_group: "Add Parent Group",
        add_sub_group: "Add Sub-Group",
        menu_edit: "Edit",
        menu_view: "View",
        menu_move: "Move Group",
        menu_make_parent: "Make a Parent Group",
        menu_delete: "Delete",
        moving_label: "You are moving:",
        move_info:
          "You have selected to move a group within hierarchy.Please select the group where you want to move the selected group. Please note that the complete hierarchy under the selected group will also move with this change.",
        confirm_move_button: "Confirm Move",
        confirm_move: {
          heading: "Confirm Group Movement",
          group_caption_left: "You are moving group",
          to: "to",
          group_caption_right: "Destination group",
          view_hierarchy: "View Hierarchy",
          toast: {
            move_failed:
              "Failed to move group. Please check the information that you have entered.",
            move_success: "Group has been moved successfully.",
          },
        },
        select_heading: "Select Groups",
        selected_h_groups_count: "Selected: {{count}}",
        selected_h_groups_count_w_limit: "Selected: {{count}} of {{limit}}",
        plus_n_more: "+{{count}} more",
        clear: "Clear Selection",
        view_heading: "View Group - {{group}}",
      },
      create_new: {
        heading: "Add New Group",
        sub_heading:
          "Please provide the information below to create a New Group",
        name: "Group Name",
        name_placeholder: "Please provide the group name",
        description: "Group Description",
        description_placeholder: "Please provide a description for the group",
        submit_button: "Create New Group",
        toast: {
          create_failed:
            "Failed to create group. Please check the information that you have entered.",
          create_success:
            "Group has been created successfully. You will be able to view groups based on your access level.",
        },
      },
      edit_group: {
        heading: "Edit Group",
        heading_new: "New Group",
        heading_readonly: "View Group",
        toast: {
          update_failed:
            "Failed to update group. Please check the information that you have entered.",
          update_success: "Group has been updated successfully.",
        },
      },
      detailsPage: {
        heading: "Specific Group View",
        sub_heading: "Edit Group",
        listing_heading: "Group Listing",
        add_new: "Add New Group",
        group: "Group",
        vehicles: "Assets",
        users: "Users",
        show_inactive_vehicles: "Show Inactive Assets",
        show_inactive_users: "Show Inactive Users",
        some_inactive_assets_might_be_hidden:
          "Some inactive assets might be hidden",
        some_inactive_users_might_be_hidden:
          "Some inactive users might be hidden",
        no_assets_found: "No assets found",
        search_placeholder_users: "Search users here...",
        group_id: "Group ID",
        group_description: "Group Description",
        group_description_placeholder:
          "The description of the group will be displayed here",
        not_in_selected_group: "Not in Selected Group",
        in_selected_group: "In Selected Group",
        active: "Active: {{count}}",
        inactive: "Inactive: {{count}}",
        search_placeholder: "Search assets here...",
        search_placeholder_group: "Search groups here...",
        add_all: "Add All",
        add_selected: "Add Selected",
        remove_selected: "Remove Selected",
        remove_all: "Remove All",
        vehicle_count_1: "1 asset",
        vehicle_count: "{{count}} assets",
        active_count_1: "1 active",
        active_count: "{{count}} active",
        toast: {
          group_not_found: "The requested group was not found.",
          group_updated: "Group has been updated successfully.",
          group_deleted: "Group has been deleted successfully.",
          updation_failed:
            "Failed to update group. Please check the information that you have entered.",
          deletion_failed: "Failed to delete group.",
        },
      },
    },
    fleettags: {
      heading: "FleetTags",
      sub_heading: "Manage your FleetTags",
      add_new: "Add New FleetTag",
      listing_heading: "FleetTag Listing",
      search_placeholder: "Search FleetTags here...",
      create_new: {
        heading: "Add New FleetTag",
        sub_heading:
          "Please provide the information below to create a New FleetTag",
        name: "FleetTag Name",
        name_placeholder: "Please provide a name for the FleetTag",
        submit_button: "Create New FleetTag",
        toast: {
          create_failed:
            "Failed to create FleetTag. Please check the information that you have entered.",
          create_success: "FleetTag has been created successfully.",
        },
      },
      detailsPage: {
        heading: "Specific FleetTag View",
        listing_heading: "FleetTag Listing",
        accord_details: "Details",
        toast: {
          fleettag_not_found: "The requested fleettag was not found.",
          fleettag_updated: "FleetTag has been updated successfully.",
          fleettag_deleted: "FleetTag has been deleted successfully.",
          updation_failed:
            "Failed to update FleetTag. Please check the information that you have entered.",
          deletion_failed: "Failed to delete FleetTag.",
        },
        form: {
          fleet_tag_id: "FleetTag ID",
          fleet_tag_name: "FleetTag Name",
          last_event_time: "Last Event Time",
          last_status_code: "Last Status Code",
          in_range: "In Range",
          in_range_device_id: "In Range Asset ID",
          last_location: "Last Location",
          last_address: "Last Address",
          last_altitude: "Last Altitude",
          distance_travelled: "Distance Travelled",
          tag_signal_strength: "Tag Signal Strength",
          tag_battery_level: "Tag Battery Level",
          temprature: "Temperature",
        },
      },
    },
    geozones: {
      heading: "Geozones",
      sub_heading: "Add and delete geozones information",
      add_new: "Add New Zone",
      listing_heading: "Geozone Listing",
      search_placeholder: "Search geozones here...",
      create_new: {
        heading: "Add New Geozone",
        sub_heading:
          "Please provide the information below to create a New Geozone",
        id: "Zone ID",
        id_placeholder: "Please provide the zone id",
        city: "City",
        type: "Zone Type(Shape)",
        submit_button: "Create New Geozone",
        toast: {
          create_failed:
            "Failed to create geozone. Please check the information that you have entered.",
          create_success: "Geozone has been created successfully.",
          create_duplicate_failed:
            "The entered Zone ID already exists. Please enter a different Zone ID.",
        },
      },
      detailsPage: {
        heading: "Specific Geozone View",
        listing_heading: "Geozone Listing",
        accord_details: "Details",
        toast: {
          geozone_not_found: "The requested geozone was not found.",
          geozone_updated: "Geozone has been updated successfully.",
          geozone_deleted: "Geozone has been deleted successfully.",
          updation_failed:
            "Failed to update geozone. Please check the information that you have entered.",
          deletion_failed: "Failed to delete geozone.",
          route_points_required:
            "Please drop at least two route points to create a route geozone.",
          polygon_points_required:
            "Please create a polygon with at least three sides to create a polygon geozone.",
          circle_points_required:
            "Please create a circle to create a circle geozone.",
          edit_not_allowed: "You are not allowed to edit this geozone.",
        },
        form: {
          geozoneid: "Zone ID",
          bluePushpin: "Drag the Blue Pin to move the Zone",
          redPushpin:
            "Drag the Red Pin(s) to change the size/shape of the Zone",
          streetaddress: "Street Address",
          streetaddress_no_options: "Type to search an address...",
          description: "Description",
          city: "City",
          zonetype: "Zone Type (Shape)",
          geocode: "Geocode",
          lat_lng: "Latitude/Longitude",
          priority: "Overlap Priority",
          assign_group: "Assign Group",
          reversegeocode: "Reverse Geocode",
          arrivalzone: "Arrival Zone",
          departurezone: "Departure Zone",
          shapecolor: "Zone Color",
          speedlimitkph: "Speed Limit",
        },
        map: {
          reset_map: "Reset Map",
          shape_controls: "Shape Controls", // deprecated
          polygon_sides: "Polygon Sides",
          route_points: "Route Points",
          data_incomplete: "The geozone data appears to be incomplete.",
          create_route_point:
            "Click anywhere on the map to create a new route point",
          route_points_max_reached:
            "Maximum limit of {{count}} route points is reached",
          corridor_radius: "Corridor Radius",
          corridor_radius_bottom_label: "in meters",
          circle_radius: "Circle Radius",
          circle_radius_hint: "Enter a value in meters and press apply.",
          radius_meters: "Radius (m)",
          polygonEdit: {
            // deprecated
            heading: "Edit Geozone Polygon",
            sub_heading:
              "You can drag the blue pushpins around to reshape the polygon.",
            ok_button: "OK",
          },
          routeEdit: {
            // deprecated
            heading: "Edit Geozone Route",
            sub_heading:
              "You can drag the blue pushpins around to reshape the route.",
            ok_button: "OK",
          },
          polygonError: {
            dragend:
              "An error occurred while dragging the pushpin. Please ensure all pushpins are forming a proper polygon.",
          },
        },
      },
    },
    geozone_categories: {
      heading: "Geozone Categories",
      sub_heading:
        "Create and delete geozone categories to control users' access to geozones",
      add_new: "Add New Geozone Category",
      listing_heading: "Geozone Category Listing",
      search_placeholder: "Search categories here...",
      create_new: {
        heading: "Add New Geozone Category",
        sub_heading:
          "Please provide the information below to create a New Geozone Category",
        geozonecategory_id: "Geozone Category ID",
        geozonecategory_id_placeholder: "Please enter the geozone category ID",
        displayname: "Display Name",
        displayname_placeholder: "Please provide a display name",
        description: "Description",
        description_placeholder: "Please provide a description",
        notes: "Notes",
        notes_placeholder: "Please enter notes (if any)",
        submit_button: "Create New Geozone Category",
        toast: {
          create_failed:
            "Failed to create geozone category. Please check the information that you have entered.",
          create_success:
            "Geozone category has been created successfully. Please associate geozones and users.",
        },
      },
      detailsPage: {
        heading: "Specific Geozone Category View",
        sub_heading:
          "Manage Geozone Categories to control users' access to geozones",
        listing_heading: "Geozone Categories",
        accord_general_details: "General Details",
        accord_geozones: "Associated Geozones",
        accord_users: "Associated Users",
        toast: {
          category_not_found: "The requested geozone category was not found.",
          category_updated: "Geozone category has been updated successfully.",
          category_deleted: "Geozone category has been deleted successfully.",
          updation_failed:
            "Failed to update geozone category. Please check the information that you have entered.",
          deletion_failed: "Failed to delete geozone category.",
        },
        form: {
          reset_default: "Reset to Default",
        },
        totals: "{{geozone_count}} geozones | {{user_count}} users",
      },
    },
    maintenance: {
      heading: "Maintenance",
      sub_heading: "Manage information for vehicle maintenance",
      listing_heading: "Asset Listing",
      search_placeholder: "Search asset here...",
      detailsPage: {
        heading: "Maintenance - Asset Specific",
        search_placeholder: "Search user here...",
        listing_heading: "Asset Listing",
        accord_odometer_details: "Maintenance Details",
        accord_maintenance_interval_details: "Maintenance Interval Details",
        accord_last_maint_engine_hours: "Last Maint Engine Hours",
        accord_last_periodic_service_date: "Last Periodic Service Date",
        toast: {
          maintenance_updated: "Maintenance Updated Successfully",
          updation_failed: "Failed to update Maintenance",
        },
        add_maintenance_form: {
          heading: "Add Maintenance Details",
          sub_heading:
            "Diesle Pump (this line item will include the value being marked.)",
          service_date: "Service Date",
          provider: "Provider",
          provider_placeholder: "Please provide a name",
          contact_name: "Contact Name",
          contact_name_placeholder: "Please provide a name",
          contact_phone: "Contact Phone",
          contact_phone_placeholder: "Please provide a phone",
          contact_email: "Contact Email",
          contact_email_placeholder: "Please provide a valid email",
          notes: "Notes",
          notes_placeholder: "Please input any notes, if required",
          cost: "Cost",
          cost_placeholder: "Please input any notes, if required",
          submit_button: "Save",
          toast: {
            add_success: "Maintenance details were added successfully",
            add_failed: "Failed to add maintenance details",
          },
        },
        form: {
          reported_odometer: "Reported Odometer",
          reported_engine_hours: "Reported Engine Hours",
          notes: "Notes",
          reminder_interval: "Reminder Interval",
          reminder_message: "Reminder Message",
          fault_codes: "Fault Codes",
          configuration_string: "Configuration String",

          maintenance_interval: "Maintenance Interval",
          due: "Due",
          remaining: "Remaining",

          label_miles: "in miles",
          label_kms: "in kms",
          label_nautical_miles: "in nautical miles",

          service_interval: "Service Interval",
          notification_window: "Notification Window",

          due_threshold_reached_confirm_completion:
            "Your asset has reached the due threshold please confirm the completion",
          mark_as_completed: "Mark as Completed",
          view_details: "View Details",
          heading: "Fault Codes",
        },
      },
    },
    incident:{
      incident_config:{
        heading: "Incident Configuration",
        sub_heading: "Choose which event types should be routed to Incident Review for manual review.",
        listing_heading: "Configure Event Types for Incident Review",
        search_placeholder: "Search here...",
        left_list_heading: "All Event Types",
        right_list_heading: "Selected for Incident Review",
        
      },
      incident_review:{
        heading: "Incident Review",
        sub_heading: "Review and manage safety incidents",
        listing_heading: "Incident Listing",
        search_placeholder: "Search incidents here...",
        export:"Export",
        no_incident_types:"No incident types found",
        csv_download_successful:"CSV download successful",
        csv_download_failed:"Error occurred while downloading CSV file.",
        csv_time_missing:"Please enter a valid start and end time.",
        detailsPage: {
          heading: "Incident Review Detail",
          fetch_error: "This incident could not be found, or you don't have access to it.",
          header_event_type: "Event Type",
          header_date_time: "Date & Time",
          header_vehicle: "Vehicle",
          header_driver: "Driver",
          download_video: "Download Video",
          downloading_video: "Downloading...",
          download_video_error: "Unable to download video for this event.",
          export_incident_report: "Export Incident Report",
          disposition_bar: {
            current_status: "Disposition:",
            reviewed_by: "Reviewed by {{name}} on {{date}}",
            popup_heading: "Confirm Disposition Change",
            popup_subheading: "You're about to change the disposition status of this incident. Please review the details and add a note before confirming",
            current_status_label: "Current Status",
            new_disposition_label: "New Disposition",
            previous_note_label: "Previous Note",
            select_placeholder: "Select...",
            locked_tooltip: "This incident is Confirmed and can no longer be changed.",
            comment_label: "Notes",
            comment_placeholder: "Add a reason or notes for this disposition...",
            comment_required_hint: "A comment is required for this disposition.",
            cancel: "Cancel",
            save: "Confirm and Change",
            saving: "Saving...",
            save_success: "Disposition updated successfully.",
            save_error: "Failed to update disposition. Please try again.",
          },
          widget_gps_map: {
            heading: "GPS Map",
          },
          widget_event_details: {
            heading: "Event Details",
            section_vehicle_driver: "Vehicle and Driver Behaviour Data",
            field_asset_id: "Asset ID",
            field_asset_name: "Asset Name",
            field_speed: "Speed",
            field_speed_limit: "Speed Limit",
            section_event_metadata: "Event Metadata",
            field_event_date: "Event Date",
            field_event_time: "Event Time",
            field_gps_location: "GPS Location",
            field_event_type: "Event Type",
            section_driver_context: "Driver Context",
            field_driver_identity: "Driver Identity",
            field_driving_hours: "Driving Hours",
            field_coaching_history: "Coaching History",
            section_violations: "System Detected Violations",
            field_adas_alerts: "Other ADAS or AI Alerts",
          },
          widget_video: {
            heading: "Incident Video",
            no_video: "No video or snapshot available for this event",
            play: "Play",
            loading: "Loading video...",
            fetch_error: "Unable to load video for this event.",
            retry: "Retry",
          },
          widget_weather: {
            heading: "Weather at Incident",
            view_detail: "View detail",
            fetch_error: "Weather data is unavailable for this incident.",
            history_hint: "Weather History (3 hours before incident)",
            location_from_gps: "Location (from GPS)",
            lat: "Lat",
            long: "Long",
            event_date_time: "Event Date & Time",
            date_label: "Date",
            time_label: "Time",
            incident_time: "Incident Time",
            field_temperature: "Temperature",
            field_feels_like: "Feels Like",
            field_wind_speed: "Wind",
            field_wind_direction: "Wind Direction",
            field_humidity: "Humidity",
            field_visibility: "Visibility",
            field_pressure: "Barometric Pressure",
            field_pressure_trend: "Pressure Trend",
            field_uv_index: "UV",
            field_precipitation: "Rain",
            field_heat_index: "Heat Index",
            field_cloud_ceiling: "Cloud Ceiling",
          },
          widget_event_report: {
            heading: "Event Report",
            view_all: "View all as Report",
            fetch_error: "Event Report is unavailable for this incident.",
            event_report_csv_successful: "Incident event report downloaded successfully.",
            event_report_csv_failed: "Incident event report downloaded failed.",
            event_report_empty:"Incident event report has no data to download."
          },
          export_incident_print:{
            dispostion: "Disposition",
            dispostion_note: "Disposition Note",
          }
        }
      }
    },
    incabcoaching:{
      heading: "In-Cab Coaching",
      sub_heading: "Configure timeout period and trigger count for each In-Cab Coaching event.",
      listing_heading: "Coaching Events",
      search_placeholder: "Search Events here...",
      details:{
        col_name:"Event Name",
        col_timeout: "Timeout Period",
        col_timeout_min: "(Minutes)",
        col_count: "Maximum Warning Count",
        col_count_range: "(0-5)",
        col_active:"Active",
        timeout_placeholder: "Set the Time Out Period",
        count_placeholder: "Set the Trigger Count",
        no_events: "No Events Found"
      }
    },
    documents: {
      heading: "Documents",
      sub_heading: "Upload and manage documents",
      add_new: "Upload Document",
      listing_heading: "Document Listing",
      search_placeholder: "Search documents here...",
      create_new: {
        heading: "Add New Document",
        sub_heading:
          "Please provide the information below to create a New Doucment",
        name: "Name",
        name_placeholder: "Please provide a name",
        file: "File",
        no_upload: "No file uploaded",
        submit_button: "Upload Document",
        toast: {
          create_failed:
            "Failed to upload document. Please check the information that you have entered.",
          create_success: "Document has been uploaded successfully.",
        },
      },
      detailsPage: {
        heading: "Document",
        search_placeholder: "Search user here...",
        listing_heading: "Document",
        active: "Linked",
        inactive: "Inactive",
        activate: "Activate",
        deactivate: "Deactivate",
        toast: {
          document_updated: "Document Updated Successfully",
          updation_failed: "Failed to update Document",
          document_not_found: "Document Not Found",
        },
      },
      edit: {
        heading: "Edit Document",
        sub_heading: "Do you want to activate this document?",
        sub_heading_inactive: "Do you want to deactivate this document?",
      },
    },
    import_export: {
      heading: "Import/Export",
      selection_heading: "Select Admin Type",
      selection_placeholder: "Select an admin type...",
      export: {
        heading: "Export Admin Template",
        template: "Download Blank Template",
        export: "Export Data",
        download_failed: "Failed to download template",
      },
      import: {
        heading: "Import Admin Template",
        import: "Import Data",
      },
      toast: {
        export_failed: "Failed to export data.",
        processing: "Your file is being processed",
        success: "Your file has been processed",
        error: "Failed to process the file",
        error_details: "Error report has been sent to your email",
        longProcess:
          "Its taking longer than expected. We will notify you via email once the file is processed",
      },
      assets: {
        heading: "Asset Map Icon and Images",
        description:
          "Use the options below to associate icons and images when preparing import file for bulk importing assets",
        button_standard: "Standard Icons",
        button_custom: "Custom Icons",
      },
      search_placeholder: "Search",
    },
    eventColors: {
      heading: "Event Colors",
      sub_heading:
        "Choose the text and background colors used for each event status in reports and the trip list. Colors are shared with Fleet Track 1.0. The status name is always shown, so color is never the only way to tell events apart.",
      search_placeholder: "Search by code or status",
      only_custom: "Only show customized",
      col_code: "Code",
      col_status: "Status",
      col_preview: "Preview",
      col_source: "Colors from",
      source_account: "This account",
      source_default: "System default",
      edit: "Edit",
      view: "View",
      preview: "Preview",
      text_colour: "Text color",
      background_colour: "Background color",
      default_colour: "Default",
      clear: "Clear",
      presets_ft1: "Fleet Track 1.0",
      presets_colorblind: "Colorblind-safe",
      contrast: "Contrast {{ratio}}:1",
      low_contrast_warning:
        "Text and background are hard to tell apart (contrast below {{min}}:1). Choose a darker or lighter color.",
      reset_to_default: "Reset to default",
      no_results: "No event statuses found.",
      toast: {
        saved: "Event colors saved.",
        reset: "Event colors reset to the system default.",
        save_failed: "Could not save the event colors.",
        load_failed: "Could not load event colors.",
      },
    },
    heatmap: {
      heading: "Heat Map Configuration",
      sub_heading: "Manage heatmap settings",
      accord_details: "Details",
      accord_authorized_groups: "Authorized Groups",
      start_event_code: "Start Event Code",
      end_event_code: "End Event Code",
      legend_configuration: "Legent Configuration",
      from: "From",
      to: "To",
      hours: "hrs",
      select_groups: "Select groups",
      group_selector_no_options: "No groups found. Type to search...",
      select_groups_placeholder: "Type to search groups...",
      detailsPage: {
        start_event_code: "Start Event Code",
        end_event_code: "End Event Code",
        legend_configuration: "Legend Configuration",
        color: "Color",
        from: "From",
        to: "To",
      },
      toast: {
        config_updated: "The heatmap configuration has been updated.",
        updation_failed: "Failed to update heatmap configuration.",
      },
    },
    crashtrack: {
      heading: "Crash Reconstruction",
      sub_heading: "View Crash Information",
      listing_heading: "Asset information",
      search_placeholder: "Search assets here...",
      detailsPage: {
        heading: "Specific Asset View",
        select_asset: "Select Asset",
        select_timestamp_date: "Incident Date",
        select_timestamp: "Incident Time",
        select_timestamp_no_items: "No incidents found",
        select_timestamp_placeholder: "Select time...",
        validation_message:
          "Please make sure to select an asset and the incident time.",
        tab_data_fetch_error: "This information could not be retrieved",

        tabs_heading: "Crash Info",

        // following slugs are used to iterate over a list, modify with caution
        tab_asset_info: {
          heading: "Asset Information",
          tableFields: {
            account: "Account",
            asset: "Asset ID",
            assetDescription: "Asset Description",
            displayname: "Display Name",
            drivername: "Driver",
            make: "Make",
            model: "Model",
            vin: "VIN",
            imei: "IMEI",
            driver: "Driver",
            groups: "Groups",
          },
        },
        tab_incident_info: {
          heading: "Incident Information",
          tableFields: {
            gforce: "G-Force",
            pre_crash_speed_limit: "Pre Crash Speed/Limit",
            event_datatime: "Event Date/Time",
            address: "Address",
            last_ign_on: "Last Ignition ON",
            elapsed_time: "Elapsed Time from Ignition ON",
            miles_driven: "Miles Driven Since Ignition ON",
            miles_driven_last24h: "Miles Driven in Last 24 Hours",
          },
        },
        tab_magnitude_graph: { heading: "Magnitude Graph" },
        tab_acceleration_graph: { heading: "Acceleration Graph" },
        tab_incident_map: { heading: "Incident Map" },
        tab_street_view: { heading: "Street View" },
        tab_weather_information: { heading: "Weather Information" },
        tab_event_report: {
          heading: "Event Report",
          tableFields: {
            timestamp: "Date/Time",
            status: "Status",
            mph: "MPH",
            heading: "Heading",
            address: "Address",
            speed_limit: "Speed Limit",
          },
        },

        print_report: "Print Report",
        close_print_mode: "Close Print Mode",
      },
    },
  },
  sysadmin: {
    enterprises: {
      heading: "Enterprise Onboarding",
      sub_heading: "Add and manage enterprises",
      add_new: "Add New Enterprise",
      listing_heading: "Enterprise Listing",
      search_placeholder: "Search enterprises here...",
      create_new: {
        heading: "Add New Enterprise",
        sub_heading:
          "Please provide the information below to create a New Enterprise",
        account_id: "Account ID",
        account_id_placeholder: "Please provide the account ID",
        description: "Description",
        description_placeholder:
          "Please provide a description for the enterprise",
        contact_name: "Contact Name",
        contact_name_placeholder: "Please provide the contact name",
        contact_phone: "Contact Phone",
        contact_phone_placeholder: "Please provide the contact phone",
        timezone: "Timezone",
        all_timezones: "All Timezones",
        timezone_placeholder: "Please select the timezone",
        user_name: "User Name (Optional)",
        user_name_placeholder: "Please provide the user name",
        contact_email: "User Email (Optional)",
        contact_email_placeholder: "Please provide the user email",
        submit_button: "Create New Enterprise",
        toast: {
          create_failed:
            "Failed to create enterprise. Please check the information that you have entered.",
          create_success: "Enterprise has been created successfully.",
        },
      },
      detailsPage: {
        heading: "Specific Enterprise View",
        sub_heading: "Manage enterprise information",
        listing_heading: "Enterprises",
        accord_general_details: "General Details",
        toast: {
          enterprise_not_found: "The requested enterprise was not found.",
          enterprise_updated: "Enterprise has been updated successfully.",
          enterprise_deleted: "Enterprise has been deleted successfully.",
          updation_failed:
            "Failed to update enterprise. Please check the information that you have entered.",
          deletion_failed: "Failed to delete enterprise.",
        },
        form: {
          account_id: "Account ID",
          account_description: "Account Description",
          creation_date: "Creation Date",
          last_login: "Last Login",
          password: "Password",
          timezone: "Timezone",
          is_active: "Is Active",
          toggleft: "Toggle FT",
          contact_name: "Contact Name",
          contact_phone: "Contact Phone Number",
          contact_email: "Contact Email",
          unlock_account: "Unlock Account",
          drivers_assigned_to_devices: "Drivers Assigned to Devices",
          session_timeout: "Session Timeout",
          session_timeout_bottom_label: "Time in seconds",
          allow_auto_add_devices: "Allow Auto Add Devices",
          maximum_devices: "Maximum Devices",
          maximum_devices_bottom_label: 'Enter "0" for unlimited',
          max_commands_locates: "Max Commands/Locates",
          total: "Total",
          total_bottom_label: "Click here to reset",
          account_manager: "Account Manager",
          is_parent: "Is Parent",
          parent_id: "Parent ID",
          private_label_name: "Private Label Name",
          geocoder_mode: "Geocoder Mode",
          border_crossing: "Border Crossing",
          dcs_properties_id: "DCS Properties ID",
          sms_properties: "SMS Properties",
          web_services: "Web Services",
          driver_elogs: "Driver ELogs",
          hos_data_on_maps: "HOS Data on Maps",
          "27_hour_reboot_option": "27 Hour Reboot Option",
          speed_behaviour_option: "Speed Behavior Option",
          dtc_popups_option: "DTC Popups Option",
          maint_labels: "Maint Labels",
          pto_labels: "PTO Labels",
          view_video_option: "View Video Option",
          sso_to_vlstracks: "SSO to VLS Tracks",
          left_menu_hamburger: "Left Menu Hamburger",
          driver_groups: "Driver",
          snapped_route: "Snapped Route",
          fleet_tag: "Fleet Tag",
          panic_sos: "Panic SOS",
          fuel_card_integration: "Fuel Card Integration",
          snow_plows: "Snow Plows",
          enablecrashtrack: "Crash Reconstruction",
          usegeocategories: "Geozone Categories",
          default_recorder: "Default Recorder",
          recorder_configurations: "Configurations",
          speed_units: "Speed Units",
          distance_units: "Distance Units",
          volume_units: "Volume Units",
          economy_units: "Economy Units",
          pressure_units: "Pressure Units",
          temperature_units: "Temperature Units",
          minidleseconds: "Minimum Idle Threshold (Minutes)",
          cameraliveviewduration: "Camera Live View Duration",
          latitude_longitude_format: "Latitude/Longitude Format",
          route_segment_color_rule: "Route Segment Color Rule",
          route_line_thickness: "Route Line Thickness",
          multi_vehicle_map_name: "Multi Vehicle Map Name",
          default_login_userId: "Default Login User ID",
          default_overlay: "Default Overlay",
          assetimageonmap: "Custom Asset Icons",
          incidentreviewallowed: "Incident Review",
          incabcoachingallowed:"In-Cab Coaching",
          serializedziptieallowed:" Serialized Zip Tie",
          userloginasallowed: "User Login As",
        },
      },
    },
    accountAccess: {
      logged_in_as: "Logged in as",
      account: "Account: {{account_name}}",
      exit_access: "Exit Access",
    },
  },
  file_upload: {
    select_file: "Select File",
    file_selected: "File Selected",
    no_file: "No file selected",
    validation: {
      file_type_not_supported:
        "Please upload a file with the following extensions: {{extensions}}",
      file_size_exceeded: "Please upload a file less than {{size}} MB",
    },
  },
  select_all: "Select All",
  yes: "Yes",
  no: "No",
  active: "Active",
  inactive: "Inactive",
  both: "Both",
  edit: "Edit",
  update: "Update",
  sms: "SMS",
  command: "Command",
  delete: "Delete",
  clear: "Clear",
  clone: "Clone",
  fill_all_required_fields: "Please fill all the required fields below",
  save: "Save",
  help: "Help",
  default: "Default",
  fourZeroFourScreen: {
    heading: "Page Not Found",
    sub_heading: "The page you are looking for does not exist.",
    back_to_home: "Back to Home",
  },
  maps: {
    receiving_data: "Receiving map data...",
    type_change_failed:
      "Google maps could not change the view for this location or the current settings.",
    type_not_supported:
      "Google does not support the selected map type for this location.",
  },
  mapFleet: {
    heading: "Map Overview",
    listing_heading: "Listing",
    search_placeholder: "Search assets here...",
    search_address_placeholder: "Search for address...",
    search_address_no_items: "No items found. Type to search...",
    no_vehicles_found: "No assets found.",
    live_updates: "Live Updates",
    button_pause: "Pause",
    button_resume: "Resume",
    updates_paused_status: "Paused",
    updates_live_status: "Live",
    frequency: "Update every",
    vehicleStatus: {
      driving: "Driving",
      idle_active: "Idle (Active)",
      idle_inactive: "Not Reporting",
      ignition_off: "Ignition Off",
    },
    filter: {
      heading: "Filters",
      address: "Find Address",
      traffic: "Traffic",
      weather: "Weather",
      street_view: "Street View",
      three_d_building: "3D Building",
      attribute_filtering: "Attribute Filtering",
      spatial_filtering: "Spatial Filtering",
      temporal_filtering: "Temporal Filtering",
      hide_geozones: "Hide Geozones",
      manage_geozones: "Manage Geozones",
      clustering: "Clustering",
      date: "Date",
      time: "Time",
      timezone: "Timezone",
      auto_refresh_timer: "Auto Refresh Timer",
    },
    vehicleFilter: {
      heading: "Filters",
      clear_filters: "Clear Filters",
      date_time: "Date & Time",
      timezone: "Timezone",
      all_timezones: "All Timezones",
    },
    layerFilter: {
      heading: "Layer Filter",
      additional_filters: "Additional Filters",
      traffic: "Traffic",
      weather: "Weather",
      three_d_building: "3D Building",
      clustering: "Clustering",
      hide_geozones: "Hide Geozones",
      manage_geozones: "Manage Geozones",
    },
    details: {
      heading: "Details",
      message: "Message",
      send_location: "Send Location",
      street_view: "Street View",
      forecast: "Forecast",
      vehicle_map_view: "Asset Map View",
      request_footage: "Request Footage",
      recorder_status: {
        standby: "The recorder is in standby mode.",
        offline: "The recorder is offline.",
        unknown: "The recorder status is unknown.",
      },
      recorder_no_cameras: "No cameras found.",
      camera_serial_number_not_found: "Camera serial number not found",
      no_videos_available: "No videos available",
      no_cameras_available: "No cameras available",
      play_video: "Play Video",
    },
    groupSelector: {
      heading: "Group Selector",
      heading_assets: "Asset Selector",
      sub_heading_group: "Please select the groups you wish to view.",
      sub_heading_asset: "Please select the assets you wish to view.",
      atleast_one_group: "Please select at least one group.",
      atleast_one_asset: "Please select at least one asset.",
    },
    weatherForecast: {
      heading: "Weather Forecast",
      now: "Now",
      rain: "Rain",
      wind: "Wind",
      uv: "UV",
      humidity: "Humidity",
      sunrise: "Sunrise",
      sunset: "Sunset",
    },
    sendSms: {
      heading: "Send SMS",
      sub_heading: "Please type in the text you wish to send",
      enter_text: "Enter Text",
      place_holder: "Your message here...",
      send: "Send",
      driver_details_not_found: "Driver details could not be found",
      toast: {
        send_success: "Message sent successfully.",
        send_failed:
          "Failed to send message. Please check the information that you have entered.",
      },
    },
    sendLocation: {
      heading: "Send Location",
      sub_heading:
        "Please provide the number with which you want to share the location.",
      phone_number: "Phone Number",
      place_holder: "Please enter a valid number",
      send: "Send As Text",
      toast: {
        send_success: "Location sent successfully.",
        send_failed:
          "Failed to send location. Please check the number you have entered.",
      },
    },
  },
  mapHeat: {
    heading: "Heat Map",
    select_groups_assets: "Select Groups / Assets",
    date_time: "Date and Time",
    date_time_tooltip:
      "Events are displayed starting {{hours}} hours prior to the selected date and time.",
    routes: "Routes",
    all_routes: "All",
    view_events_button: "View Events",
    route_n: "Route {{n}}",
    listing_heading: "Listing",
    search_placeholder: "Search assets here...",
    search_address_placeholder: "Search for address...",
    search_address_no_items: "No items found. Type to search...",
    no_vehicles_found: "No asset routes found.",
    no_routes_found: "No routes found.",
    no_config_set: "Please set up the heat map configuration.",
    legends: "Legend",
    legend_from_to_hours: "{{from}}-{{to}} Hours",
    legend_over_n_hours: "Over {{n}} Hours",
    line_styles: {
      point_to_point: "Point To Point",
      snap_to_roads: "Snap To Road",
      directions_service: "Direction Service",
      default: "Default",
    },
    filter: {
      heading: "Filters",
      address: "Find Address",
      traffic: "Traffic",
      weather: "Weather",
      street_view: "Street View",
      three_d_building: "3D Building",
      attribute_filtering: "Attribute Filtering",
      spatial_filtering: "Spatial Filtering",
      temporal_filtering: "Temporal Filtering",
      hide_geozones: "Hide Geozones",
      manage_geozones: "Manage Geozones",
      clustering: "Clustering",
      date: "Date",
      time: "Time",
      timezone: "Timezone",
      auto_refresh_timer: "Auto Refresh Timer",
    },
    // vehicleFilter: {
    //   heading: "Filters",
    //   clear_filters: "Clear Filters",
    //   date_time: "Date & Time",
    //   timezone: "Timezone",
    //   all_timezones: "All Timezones",
    // },
    layerFilter: {
      heading: "Layer Filter",
      additional_filters: "Additional Filters",
      traffic: "Traffic",
      weather: "Weather",
      three_d_building: "3D Building",
      clustering: "Clustering",
      hide_geozones: "Hide Geozones",
      manage_geozones: "Manage Geozones",
    },
    groupSelector: {
      heading: "Group Selector",
      heading_assets: "Asset Selector",
      sub_heading_group: "Please select the groups you wish to view.",
      sub_heading_asset: "Please select the assets you wish to view.",
      atleast_one_group: "Please select at least one group.",
      atleast_one_asset: "Please select at least one asset.",
    },
  },
  vehicleMap: {
    selected_vehicle: "Selected Asset",
    selected_vehicle_no_options: "No assets found. Please try another search.",
    search_address_placeholder: "Search for address...",
    search_address_no_items: "No items found. Type to search...",
    loading_vehicle_data: "Loading asset data...",
    no_trip_data: "No trip data found.",
    video_camera_n: "Camera {{number}}",
    live_updates: "Live Updates",
    button_pause: "Pause",
    button_resume: "Resume",
    updates_paused_status: "Paused",
    updates_live_status: "Live",
    updates_off_status: "Off",
    updates_off_past_date:
      "A past date is selected - that day has nothing further to report.",
    frequency: "Update every",
    tripDetails: {
      heading: "Trip Details",
      duration: "Duration",
      total_events: "Total Events",
      summary_idling: "Idling",
      summary_stops: "Stops",
      summary_max_speed: "Max Speed",
      summary_violations: "Violations",
      summary_count_for_duration: "{{total}} · {{duration}}",
      show_events: "Show all",
      hide_events: "Hide",
      row_stopped_for: "Stopped for",
      row_idling_for: "Idling for",
      buzzer_alert: "Panic Alert",
      trip_number: "Trip {{number}}",
      incident_trip: "Trip",
      view_details: "View Details",
      replay_events: "Replay Events",
      partial_trip: "Partial Trip",
      completed_trip: "Completed Trip",
      active_trip: "Active Trip",
      non_trip: "Non-Trip",
    },
    event_filter_button: "Event Filter",
    eventFilter: {
      heading: "Event Filter",
      all_event: "All Event",
      accelerated: "Accelerated",
      button_pressed: "Button Pressed",
      d_accelerated: "D Accelerated",
      distracted_driving: "Distracted Driving",
      driver_check_in: "Driver Check In",
      driver_check_out: "Driver Check Out",
      driver_unbelted: "Driver Unbelted",
      idling: "Idling",
      speeding: "Speeding",
      traffic: "Traffic",
      weather: "Weather",
    },
    line_style_filter: "Route Views Filter",
    line_styles: {
      default: "Default",
      point_to_point: "Point to Point",
      snap_to_roads: "Snap to Roads",
      directions_service: "Directions Service",
    },
    vehicleTripFilter: {
      heading: "Filters",
      clear_filters: "Clear Filters",
      selected_date: "Date For",
      date_from: "Date From",
      date_to: "Date To",
      time_from: "Time From",
      time_to: "Time To",
      timezone: "Timezone",
      all_timezones: "All Timezones",
    },
  },
  whiteLabeling: {
    heading: "White Labeling",
    sub_heading: "Add and manage domains",
    listing_heading: "Domain Listing",
    add_new: "Add New",
    search_placeholder: "Search domains here...",
    whiteLabelSettings: {
      listing_heading: "Domain List",
      heading: "Configurations",
      sub_heading:
        "Customize the look and feel of your platform to match the brand.",
      domain_prefix: "Domain Prefix",
      domain_prefix_subtitile: "https://example.fleettrack.com",
      brand_name: "Brand Name",
      brand_name_subtitile: "Enter Brand Name",
      header_content: "Header Content",
      description: "Description",
      meta_title: "Meta Title",
      meta_description: "Meta Description",
      limit_subtext: "~ limit to 60 characters",
      limit_subtext_lg: "~ limit to 160 characters",
      color_theme: "Color Theme",
      brandLogo: "Brand Logo",
      background_image: "Background Image",
      fav_icon: "Fav Icon",
    },
    deleteModal: {
      heading: "Delete Domain",
      sub_heading: "Are you sure you want to delete this domain?",
      confirm_button: "Delete",
      toast: {
        delete_success: "Domain has been deleted successfully.",
        delete_failed: "Failed to delete domain.",
      },
    },
  },
  PrivateXML: {
    acl: {
      accountAdmin: "Account Administration",
      // "userAdminSelf": "User Administration (DT)",
      // "userAdminSelf": "User Administration (OLD)",
      // "userAdminAll": "User Administration (OLD) (All users)",
      // "userAdminACL": "User Administration (OLD) (ACL access)",
      // "userAdminGroups": "User Administration (OLD) (Group)",
      // "userAdminRole": "User Administration (OLD) (Role)",
      // "userAdminDeviceID": "User Administration (OLD) (Preferred DeviceID)",

      userAdminSelf: "User Administration (Current user)",
      userAdminAll: "User Administration (All users)",
      userAdminACL: "User Administration (ACL access)",
      userAdminGroups: "User Administration (Group)",
      userAdminRole: "User Administration (Role)",
      userAdminDeviceID: "User Administration (Preferred DeviceID)",
      userAdminNotifyEmail: "User Administration (Notify Email)",

      roleAdmin: "Role Administration",
      deviceAdmin: "Device Administration",
      // "deviceAdminDT": "Device Administration (DT)",
      // Device/Driver Search
      // "deviceSearch": "Device Search",
      driverSearch: "Driver Search",

      ruleAdminDriver: "Driver Checkbox Rule Admin",

      deviceMaintAdmin: "Device Maintenance Only Administration",
      deviceAdminUniqID: "Device Administration (Device UniqueID)",
      deviceAdminborderCalendar: "Show Calendar for Border Crossing",
      deviceType: "Device Administration (Device Type)",
      deviceAdminActive: "Device Administration (Device Active)",
      deviceAdminServID: "Device Administration (Server ID)",
      deviceAdminFirmware: "Device Administration (Firmware)",
      deviceAdminRules: "Device Administration (Notification Rules)",
      deviceAdminCommands: "Device Administration (Commands)",
      deviceAdminSms: "Device Administration (SMS Commands)",
      deviceAdminEditSms: "Device Administration (Edit SMS)",
      deviceAdminEditSIM: "Device Administration (Edit SIM)",
      deviceAdminEditEqStat: "Device Administration (Edit Equip Status)",
      deviceAdminEditIMEI: "Device Administration (Edit IMEI)",
      deviceAdminEditSerial: "Device Administration (Edit Serial#)",
      deviceAdminEditDatKey: "Device Administration (Edit DataKey)",
      deviceAdminFuelEconom: "Device Administration (Fuel Economy)",
      deviceAdminFuelProfil: "Device Administration (Fuel Profile)",
      deviceAdminFuelCapac: "Device Administration (Fuel Capacity)",
      // "deviceAdminFuelCapac": "Device Administration (Fuel Capacity)",
      deviceAdminRouteSegColorSel:
        "Device Administration (Route Segment Color Selector)",
      deviceAdminEditCameraID: "Device Administration (Camera ID)",
      deviceAdminPendingPingCmd: "Device Administration (Pending Ping Cmd)",
      deviceAdminAssetWorksFlag: "Device Administration (Asset Works Flag)",
      deviceAdminAllowVinDecode: "Device Administration (Allow VIN Decode)",
      deviceAdminAllowClearOdomOffset:
        "Device Administration (Clear Odom and Offset)",
      deviceAdminAllowClearEngHrsOffset:
        "Device Administration (Clear Eng Hours and Offset)",
      deviceAdminEditStatusCodes:
        "Device Administration (Dynamic Status Codes)",

      deviceAlerts: "Device Alerts",
      alertPanel: "Alert Panel",
      reportjob: "Scheduled Reports Administration",
      reportjobEmailList: "Scheduled Reports Email DropDown",
      eLogHOS: "ELog/HOS Administration",
      cameraMedia: "Smart Witness Portal",
      groupAdmin: "Group Administration",
      // "groupAdmin": "Group Administration (Parent Group)",
      zoneCategoryAdmin: "Geozone Category Administration",
      driverAdmin: "Driver Administration",
      // "driverAdmin": "Driver Administration",
      driverGroup: "Driver Group Administration",
      // "driverAdminManager": "Driver Manager Admin",
      // "driverAdminEditDrvMgr": "Driver Administration (Edit Driver Managers)",
      // "driverAdminEditDrvGrp": "Driver Administration (Edit Driver Groups)",
      driverAdminManagerLicense: "Driver Admin(License)",
      driverAdminManagerFuelCardID: "Driver Admin(Fuel Card ID)",
      driverAdminSendMassMsgOk: "Driver (Send Mass Texts to Drivers)",
      active: "Driver (Edit Active)",
      driverAdminBadge: "Driver (Employee ID)",
      driverAdminCard: "Driver (Card ID)",
      entityAdmin: "Entity Administration",
      entityAdminRFID: "Entity Administration (FleetTag)",
      entityAdminTrailer: "Entity Administration (Trailer)",
      entityAdminPerson: "Entity Administration (Person)",
      entityAdminPackage: "Entity Administration (Package)",
      // "entityAdminFleetTags": "Entity Administration (FleetTag)",
      zoneAdmin: "Geozone Administration",
      zoneAdminPurposeID: "Geozone Purpose ID",
      corridorAdmin: "GeoCorridor Administration",
      statusCodeAdmin: "StatusCode Administration",
      ruleAdmin: "Rule Administration",
      //  "ruleAdminNew": "Rules Wizard",
      changePassword: "Change Password",
      helpMenu: "Help Menu",
      videoView: "Video View",
      customReports: "Custom Reports",
      activeInactive: "Active/Inactive Device Toggle",

      // HTML Wrapper
      htmlWrapper: "Generic HTML Wrapper",
      // system admin
      systemAdmin: "System Administration",
      systemAdminDeviceLookup: "System Admin (Device Lookup)",
      systemAdminCameraLookup: "System Admin (Camera Lookup)",
      systemAdminVINLookup: "System Admin (VIN Lookup)",
      "admin.sysAdmin": "System Admin Properties",
      systemAdminAccounts: "System Administration Account Logins",
      systemAdminLAF: "System Administration Look and Feel",
      allowRebootOption: "Allow 27 Hour Reboot Option",
      allowSpeedOption: "System Admin (Set Show Speeding Behavior Flag)",
      allowDTCPopups: "System Admin (Set Show DTC Popups)",

      // maps
      deviceMap: "Device Map Display",
      deviceMapAuto: "Device Map (Auto Update)",
      deviceMapLast: "Device Last Location Map Display",
      deviceMapLastAuto: "Device Last Location Map (Auto Update)",
      deviceMapShowGroupsOnPopup: "Map (Show Groups on Popup)",
      deviceMapShowGroupsOnRpt: "Map (Show Groups on Report)",
      // LBT-218
      deviceMapReport: "Device Map (PDF with Map Report)",
      deviceMapExtras: "Map (Include Non-Consumer Fields)",
      deviceStopTimer: "Map (Stop Timer on click of PP or Cal)",
      // LBT-218
      fleetMap: "Group Map",
      fleetMapAuto: "Fleet/Group Map (Auto Update)",
      fastFleetMap: "Fast Group Map",
      fastFleetMapAuto: "Fast Group Map (Auto Update)",
      // LBT-212
      fleetMapFuelEx: "Fuel Event Exception Map",
      fleetMapFuelExAuto: "Fuel Event Exception Map (Auto Update)",
      // LBT-212
      // LBT-176
      fleetMapCat: "Fleet/Group Map By Zone Category",
      fleetMapCatAuto: "Fleet/Group Map By Zone Category (Auto Update)",
      // LBT-176
      fleetMapSOS: "SOS/Emergency Map",
      fleetMapDailyStop: "Daily Stop Map",
      toggleGeozones: "Toggle Geozones On/Off",
      mapAltSpeedLimit: "Map (Alternate Speed Limit)",

      // LBT-382
      mapOverlay: "Show Map Overlays",

      multiVehicle: "Multi Asset Map",

      mapStatusCodes: "Map Status Code Filter",
      sendText: "Map Send Text Messages",
      streetView: "Map Street View",
      videoCam: "Map View Video",
      crashTrack: "Map Crash Track",
      viewFuelData: "View Fuel Data",
      mapGeoDropdown: "Map Geozone Dropdown",
      devicePursuitMap: "Asset Pursuit Map",

      // "trackSky": "Sky Track Map",
      // "trackSkyAuto": "Sky Track Map (Auto Update)",
      // report groups
      reportDetail: "Report Group (Detail)",
      reportDriver: "Report Driver (Detail)",
      myReports: "My Reports",
      reportSummary: "Report Group (Summary)",
      reportPerformance: "Report Group (Performance)",
      reportIFTA: "Report Group (I.F.T.A.)",
      reportGroupIFTA: "Report Group (I.F.T.A. Group)",
      reportTableAdmin: "Report Group (Table Admin)",
      reportSysAdmin: "Report Group (SystemAdmin)",
      "reportMenu.table": "Allow Table Format Reports",
      dashMain: "Dash Main",
      dashConfig: "Dashboard Configuration",
      dashFuelTile: "Dashboard Fuel Usage Tile",
      dashDelinquentTile: "Dashboard Delinquent Devices Tile",
      alertsTile: "Dashboard Alerts Tile",
      tamperTile: "Dashboard Tamper Events Tile",
      mileageTile: "Dashboard Mileage Summary Tile",
      customTile: "Dashboard Custom Demo Tile",
      dashDtcFaultCodesTile: "Dashboard DTC Fault Codes Tile",
      dashMilesPlowedTile: "Dashboard Miles Plowed Tile",
      snowplow: "Dashboard Snowplow",
      // "reportSysAdmin": "Dashboard QuickSight",
      // LBT-353 - New Score Card
      scorecard: "New Behavior Score Card",
      dashredesign: "Dashboard Redesign",
      showSpeeding: "Report/Maps (Show Speeding Behavior)",
      // LBT-396 - Message Center
      messageCenter: "Message Center",
      messageInfo: "Messages",
      videoDashboard: "Video Dashboard",
      // report type access
      "report.csv": "Report CSV",
      "report.email": "Report Email",
      "report.excel": "Report Excel",
      // "report.eventDetail": "Report XML",
      "report.pdf": "Report PDF",
      "report.scheduleFmt": "Report Schedule",
      // report access
      "report.rptDetail31": "Report (Allow 31 Days)",
      "report.3report31Days": "Report (3 for 31 Days)",
      // "report.motionSummary": "Report (3 for 31 Days)",

      "report.eventDetail": "Report (Event Detail)",
      "report.eventDetailAll": "Report (Event Detail All)",
      "report.eventDetailAH": "Report (Event Detail AH)",
      "report.eventDetailAHGD": "Report (Event Detail AHDG)",
      //      "report.eventDetail": "Report (OBD Event Detail)",
      //      "report.eventDetail": "Report (OBD Event Detail Light)",
      "report.eventDetailOBDLightGroup": "Report (OBD Event Detail By Group)",
      //     "report.eventDetail": "Report (Pursuit Event Detail)",
      "report.harshBraking": "Report (Harsh Braking)",
      "report.harshAccel": "Report (Harsh Acceleration)",
      "report.vehicleUtil": "Report (Asset Utilization)",
      "report.vehicleUtil2": "Report (Expanded Asset Utilization)",
      "report.vehicleUtil3": "Report (Expanded Asset Utilization2)",
      "report.vehicleUtil4":
        "Report (Expanded Asset Utilization (with Idle Cnt))",
      "report.VehicleUtilLastInGeo":
        "Report (Asset Utilization Last In Geozone)",
      "report.odometerReport": "Report (Odometer Report)",
      "report.odometerReport2": "Report (Odometer Report for Bedford)",
      //    "report.eventDetail": "Report (Weekend Usage)",
      //     "report.eventDetailAllELD": "Report (Event Detail All Fields for ELD)",
      "report.fleetSummary": "Report (Fleet/Group Summary)",

      "report.lastReportIn": "Report (Device Reporting Status/12V Power Loss)",

      //   "report.eventCount": "Report (Event Count)",
      "report.speedOption": "Report (Speeds over Selected Value)",
      //    "report.malFuncFault": "Report (Malfunction Lamp and Fault Codes)",
      "report.malFuncFaultLinks": "Report (Last Fault Codes With Links)",
      "report.speedPosted": "Report (Speeds over Posted Limit)",
      //   "report.excessSpeed": "Report (Excess Speed Status Code)",
      //     "report.lastVehicleBatteryVolts": "Report (Last Asset Battery Volts)",
      "report.motionSummary": "Report (Driving/Idle Time Device Summary)",
      //     "report.motionSummaryTest": "Report (Idle Report By Day)",
      "report.driverTrip": "Report (Driver Trip Report)",
      "report.driver": "Report (Driver Report)",
      "report.driverIdle": "Report (Driver Idle Report)",
      "report.driverSpeeding": "Report (Driver Speeding Report)",
      "report.driverHarshAccel": "Report (Driver Harsh Acceleration Report)",
      "report.driverPostedSpeed": "Report (Driver Exceeding Posted Report)",
      "report.driverHarshBrake": "Report (Driver Harsh Braking Report)",
      "report.driverTimeSummary":
        "Report (Driver Driving/Stopped Time Summary)",
      "report.firstLastIgnitionReport":
        "Report (First and Last Ignition Report)",
      "report.driverDistance": "Report (Driver Distance Traveled Report)",
      "report.driverMileage": "Report (Driver Mileage Report)",
      "report.driverIgnition": "Report (Driver Ignition Report)",
      "report.driverMedExp": "Report (Medical Card Expiring Report)",
      "report.driverTwicExp": "Report (TWIC Expiring Report)",
      "report.MTAFleetIdle": "Report (MTA Group Idle Report)",
      "report.MTAActivityReport": "Report (Activity Summary Report)",
      "report.ctivitySummaryWithDrivers":
        "Report (Activity Summary With Drivers)",
      "report.fleetMotion": "Report (Driving/Idle Time Fleet Summary)",
      "report.fleetMotion2":
        "Report (Driving/Idle Time Fleet Summary using Digital Input 2)",
      //      "report.fleetGearSummary": "Report (Fleet Gear Usage Report)",
      "report.fasterFuel": `Report ("Faster" Fuel Report)`,
      // 	"report.checkInWeeks": "Report (1/2/3 week Check-In Report)",
      "report.fleetFuel": "Report (Fleet Fuel Summary)",
      "report.delinquentVehicles": "Report (Delinquent Assets)",
      "report.thermo": "Report (Temperature)",
      "report.thermo.group": "Report (Temp Monitor by Group)",
      "report.j1708Fault": "Report (J1708 Fault)",
      "report.propertyValue": "Report (Property Value)",
      "report.diagValue": "Report (Error/Diagnostic Value)",
      "report.tripReport": "Report (Trip Report Detail)",
      "report.tripReportDriver": "Report (Trip Detail by Driver)",
      "report.tripEndReport": "Report (Trip Report (Autozone))",
      "report.bCrossDetail": "Report (Border-Crossing Detail)",
      "report.bCrossSummary": "Report (Border-Crossing Summary)",
      "report.bCrossGroupDetail": "Report Group (Border-Crossing Detail)",
      "report.bCrossGroupSummary": "Report Group (Border-Crossing Summary)",
      "report.bCrossGroupStateSummary":
        "Report Group (I.F.T.A State Mileage Summary)",
      "report.userDetail": "Report (User Detail)",
      "report.deviceGroupDetail": "Report (Device Group Detail)",
      "report.userLogin": "Report (User Login)",
      "report.userLoginCnt": "Report (User Login Count Summary)",
      "report.fuelRegister": "Report (Fuel Register)",
      "report.notifyQueue": "Report (Notify Queue)",
      "report.maintHistoryGroup": "Report (Maint History Group)",
      "report.maintHistoryVehicle": "Report (Maint History Asset)",

      "report.notifyQueueTamper": "Report (Tamper Alerts)",
      "report.countSummary": "Report (Status Count Summary)",
      //      "report.behavior.consol": "Report (Consolidated Asset/Driver Behavior)",
      "report.dashboard.behavior": "Report (Dashboard Behavior)",
      "report.dashboard.behavior2": "Report (Dashboard Behavior2)",
      //     "report.vehicleBehaviorELDS": "Report (Asset/Driver Behavior Using Engine RPM)",
      "report.dashboard.behavior3":
        "Report (Asset/Driver Behavior (Speeding by Event))",
      "report.entitySummary": "Report (Entity Summary)",
      "report.fleetTagDetail": "Report (FleetTag Detail)",
      "report.acctLastLogin": "Report (Account Last Login)",
      "report.unassignedDev": "Report (Unassigned Devices)",
      "report.billingException": "Report (One-to-Many Billing Exception)",
      "report.delinquentDevices": "Report (Delinquent Devices)",
      "report.delinquentDevicesDetail": "Report (Delinquent Devices Detail)",
      "report.stateOfDevices": "Report (State Of Devices)",
      "report.dbAuditReport": "Report (Device Audit Report)",
      "report.AuditReport": "Report (Audit Report)",

      // These two are for STC
      // "report.notifyQueue": "Report (Outside of Geozones)",
      // "report.dbAuditReport": "Report (Currently in Geozone)",

      //    "report.periodicMain": "Report (Consolidated Service)",
      "report.periodicMain": "Report (Preventative Maintenance By Type)",

      "report.fleetPTOUse": "Report (Consolidated PTO Usage)",
      //     "report.distTravel": "Report (Distance Traveled)",
      "report.vehBehavior": "Report (Asset/Driver Behavior)",
      "report.ignitionDetail": "Report (Ignition Detail)",
      "report.seatbeltReport": "Report (Seatbelt Report)",
      "report.seatbeltTimeDistanceReport":
        "Report (Seatbelt Time/Distance Report)",

      "report.reverseReport": " Report (Reverse Report)",
      // "report.GearSummary": "Report (Gear Selector Report by Group)",
      "report.digInputDetail": "Report (Digital Input Detail)",
      //      "report.liftArmDig1": "Report (Garbage Truck Lift Arm)",
      "report.mowerOnOffDig2": "Report (Mower On/Off)",
      "report.vehicleList": "   Report (Asset List)",
      "report.autozoneMonthlyBilling": "   Report (Autozone Monthly Billing)",
      //   "report.TripSpeedingReport": "   Report (Autozone Speeding Report)",
      "report.AutozoneSpeedingReport":
        "   Report (Pre-Processed Autozone Speeding Report)",
      // "report.histGeoLU": "Report (Historical Geozone Lookup)",
      "report.histGeoLUMap": "Report (Historical Geozone Lookup Map)",
      "report.fuelProdData": "Report (Fuel Product Data)",
      // 	"report.fuelDistanceReport": "Report (Fuel Distance Report)",
      "report.fuelEventException": "Report (Fuel Event Exception Report)",

      "report.fleetIdlePTOSummary": "Report (Fleet Idle Report with PTO)",

      //  "report.fleetManagement": "Report (Fleet Management Report)",
      "report.fuelConsumptionData": "Report (Fuel Consumption Data)",
      //     "report.dpfNonCompliance": "Report (DPF Non-Compliance)",
      "report.idleDetail": "Report (Excessive Idle Detail)",
      "report.idleDetailGeozone": "Report (Idling In Geozones)",
      "report.idleDetailGeozone2": "Report (Idling In Geozones2)",
      "report.geozone": "Report (Geozone)",
      "report.geozoneElapsed": "Report (Geozone Elapsed Times (by Group))",
      //    "report.geozoneBilling": "Report (Allocate Miles to Geozones)",
      // LBT-176
      "report.geozoneCat": "Report (Geozone By Category)",

      "report.abnormalOdom": "Report (Abnormal Odom Jump)",

      // LBT-176
      //    "report.job": "Report (Job)",
      "report.devNearDevice": "Report (Devices Near Device)",
      "report.devNearGeozone": "Report (Devices Near Geozone)",
      "report.devNearGeozoneCat": "Report (Devices Near Geozone By Category)",
      "report.antxDetail": "Report (Antx Detail)",
      "report.antxSummary": "Report (Antx Summary)",
      "report.snowPlowDetail": "Report (Snow Plow Detail)",
      "report.snowPlowDetailGroup": "Report (Snow Plow Detail (by Group))",
      //   "report.stopReportDetail": "Report (Stop Report Detail Using Ign On/Off Events)",
      //   "report.stopReportDetail": "Report (Stop Report Detail Using Motion Start/Stop (Engine On))",
      "report.StopReportGroupIgn":
        "Report (Stop Report By Group Using Ign On/Off Events))",
      "report.StopReportGroupMotion":
        "Report (Stop Report By Group Using Motion Start/Stop (Engine On))",

      "report.DailyUtilGroup":
        "Report (Daily Utilization by Group (Utilization starts at 1st Ign On and ends at Last Ign Off Each Day))",

      "report.invalidDriverEvents": "Report (Driver Violations (MTA))",

      "report.driverUtilSummary": "Report (Driver ID Utilization Summary)",

      "report.oilPressureRpt": "Report (Oil Pressure)",

      "report.idleRptWithPTO": "Report (Idle Detail With PTO (MTA))",
      "report.idleRptWithPTO_group":
        "Report (Idle Detail With PTO (MTA - GROUP))",

      "report.idleRptWithPTO_summary":
        "Report (Idle Detail With PTO (MTA - SUMMARY))",

      "report.idleSummary": "Report (Idle Summary)",
      "report.ignitionSummaryReport": "Report (Ignition Summary)",
      "report.customizeReports": "Report (Customize)",

      "map.useGroupGeozones": "Use Geozone Group ID on Maps",

      //   "fleetops": "FleetOps Page",
      fleetops: "FleetHOS Page",

      // "Service" command access
      "service.version": `Service Command "version"`,
      "service.dbget": `Service Command "dbget"`,
      "service.dbcreate": `Service Command "dbcreate"`,
      "service.dbput": `Service Command "dbput"`,
      "service.dbdel": `Service Command "dbdel"`,
      "service.dbschema": `Service Command "dbschema"`,
      "service.propget": `Service Command "propget"`,
      "service.reportlist": `Service Command "reportlist"`,
      "service.report": `Service Command "report"`,
      "service.mapdata": `Service Command "mapdata"`,
      "service.eventdata": `Service Command "eventdata"`,
      "service.pushpins": `Service Command "pushpins"`,
      "service.messages": `Service Command "messages"`,
      "service.commands": `Service Command "commands"`,
      "service.statuscodes": `Service Command "statuscodes"`,
      "service.devcmd": `Service Command "devcmd"`,
      "service.devinventory": `Service Command "devinventory"`,
      // Enfora command access
      "enfora.commands": "${dcsDesc} Commands",
      "enfora.LocateNow": "${dcsDesc} (LocateNow)",
      "enfora.LocateSMS": "${dcsDesc} (LocateSMS)",
      "enfora.Output_on": "${dcsDesc} (Output On)",
      "enfora.Output_off": "${dcsDesc} (Output Off)",
      "enfora.Output1_on": "${dcsDesc} (Output #1 On)",
      "enfora.Output1_off": "${dcsDesc} (Output #1 Off)",
      "enfora.Output2_on": "${dcsDesc} (Output #2 On)",
      "enfora.Output2_off": "${dcsDesc} (Output #2 Off)",
      "enfora.Output3_on": "${dcsDesc} (Output #3 On)",
      "enfora.Output3_off": "${dcsDesc} (Output #3 Off)",
      "enfora.Geozones": "${dcsDesc} (Geozones)",
      "enfora.DriverMessUDP": "${dcsDesc} (DriverMessage UDP)",
      "enfora.DriverMessSMS": "${dcsDesc} (DriverMessage SMS)",
      "enfora.CannedMessages": "${dcsDesc} (CannedMessages)",
      "enfora.CannedMessage1": "${dcsDesc} (CannedMessage1)",
      "enfora.CannedMessage2": "${dcsDesc} (CannedMessage2)",
      "enfora.CannedMessage3": "${dcsDesc} (CannedMessage3)",
      "enfora.SetDriverID": "${dcsDesc} (SetDriverID)",
      "enfora.ATCommandUDP": "${dcsDesc} (ATCommand UDP)",
      "enfora.ATCommandSMS": "${dcsDesc} (ATCommand SMS)",
      //
      // CalAmp command access
      "calamp.commands": "${dcsDesc} Commands",
      "calamp.LocateNow": "${dcsDesc} (LocateNow)",
      "calamp.LocateSMS": "${dcsDesc} (LocateSMS)",
      "calamp.DoorUnlock": "${dcsDesc} (DoorUnlock)",
      "calamp.StarterDisable": "${dcsDesc} (StarterDisable)",
      "calamp.StarterEnable": "${dcsDesc} (StarterEnable)",
      "calamp.StarterDisableUDP": "${dcsDesc} (StarterDisableUDP)",
      "calamp.StarterEnableUDP": "${dcsDesc} (StarterEnableUDP)",
      "calamp.DriverIdBuzzerOn": "${dcsDesc} (RFIDBuzzerOn)",
      "calamp.DriverIdBuzzerOff": "${dcsDesc} (RFIDBuzzerOff)",
      "calamp.CustomCommandCalamp": "${dcsDesc} (Custom Command)",
      "calampaz.CustomCommandCalampAZ": "Calamp AZ (Custom Command)",
      "calamprr.CustomCommandCalampRR": "Calamp RR (Custom Command)",
      "geometris2.CustomCommandGeometrisQA": "Geometris QA (Custom Command)",
      "teltonika.CustomCommandTeltonika": "Teltonika (Custom Command)",
      "xirgo.CustomCommandXirgo": "Xirgo (Custom Command)",
      "calamp.3640BuzzerOn": "${dcsDesc} (Temporary Buzzer On)",
      "calamp.BuzzerOn10Beeps": "${dcsDesc} (Temporary Buzzer On)",
      // "calamp.ATCommandSMS": "${dcsDesc} (ATCommand UDP)",
      // "calamp.ATCommandUDP": "${dcsDesc} (Custom Command)",
      "calamp.OBDSettings": "${dcsDesc} (Device Admin OBD Config Toggles)",

      // geometris2 command access
      "geometris2.commands": "${dcsDesc} Commands",
      "geometris2.LocateNow": "${dcsDesc} (Locate Now)",
      "geometris2.UpdateFirmware84": "${dcsDesc} (Update Firmware)",
      // "geometris2.UpdateFirmware87": "${dcsDesc} (Update Firmware)",
      "geometris2.ATCommandUDP": "${dcsDesc} (ATCommand UDP)",

      //
      // eLoc GL100 command access
      "eloc.commands": "${dcsDesc} Commands",
      "eloc.LocateNow": "${dcsDesc} (LocateNow)",
      "eloc.LocateSMS": "${dcsDesc} (LocateSMS)",
      "eloc.60SecUpdate": "${dcsDesc} (60SecUpdate)",
      "eloc.120SecUpdate": "${dcsDesc} (120SecUpdate)",
      "eloc.ATCommandSMS": "${dcsDesc} (ATCommandSMS)",
      //
      // QGV300
      "dcs.qgv300-LocateNow": "${dcsDesc} (LocateNow)",
      "dcs.qgv300-ATCommandSMS": "${dcsDesc} (ATCommand SMS)",
      "dcs.qgv300-ATCommandUDP": "${dcsDesc} (ATCommand UDP)",
      "dcs.qgv300-RebootDevice": "${dcsDesc} (Reboot Device)",

      "dcs.qgv300-EnableKeyfob": "${dcsDesc} (EnableKeyfob)",
      "dcs.qgv300-DisableKeyfob": "${dcsDesc} (DisableKeyfob)",
      "dcs.qgv300-UnlockStarter": "${dcsDesc} (UnlockStarter)",
      "dcs.qgv300-LockStarter": "${dcsDesc} (LockStarter)",
      "dcs.qgv300-UnlockDoor": "${dcsDesc} (UnlockDoor)",
      "dcs.qgv300-UnlockDoor2": "${dcsDesc} (UnlockDoor2)",
      // QGV500
      "dcs.qgv500-LocateNow": "${dcsDesc} (LocateNow)",
      "dcs.qgv500-ATCommandSMS": "${dcsDesc} (ATCommand SMS)",
      "dcs.qgv500-RebootDevice": "${dcsDesc} (Reboot Device)",
    },
  },
  reports: {
    color_mode: {
      turn_on: "Color view: dark background, colored statuses, all rows",
      turn_off: "Back to standard view",
      rows_loaded: "{{loaded}} of {{total}} rows loaded",
      all_rows_loaded: "All {{total}} rows loaded",
      loading_more: "Loading more rows…",
    },
    selectAType: {
      heading: "Report",
      add_new_button: "Add New Report",
      search_placeholder: "Search for reports here...",

      no_items: "No items",

      toast: {
        get_specific_report_error: "Failed to get specific report details",
      },
    },
    optionsForm: {
      heading: "Report Filter",
      sub_heading: "Please select the filters for the report",
      no_filters_continue_message:
        "All good! Please click on the button below to proceed",
      submit_button: "Generate",
      // dropdowns and known fields
      device_id: "Asset",
      device_id_placeholder: "Select an Asset",
      device_id_no_item: "No matching assets found",
      device_id_search_items_count: "Search from {{count}} assets",
      driver_id: "Driver",
      driver_id_placeholder: "Select a Driver",
      driver_id_no_item: "No matching drivers found",
      driver_id_search_items_count: "Search from {{count}} drivers",
      geozone_id: "Geozone",
      geozone_id_placeholder: "Select a Geozone",
      geozone_id_no_item: "No matching geozone found",
      geozone_id_search_items_count: "Search from {{count}} geozone",
      device_groups_id: "Group",
      device_groups_placeholder: "Select a Group",
      device_groups_no_item: "No matching group found",
      device_groups_search_items_count: "Search from {{count}} groups",
      start_time: "Date From",
      end_time: "Date To",
      timezone: "Timezone",
      timezone_placeholder: "Select a Timezone",
      time_toggle_label_off: "Range",
      time_toggle_label_on: "Calendar",
      time_range: "Time Range",
      time_range_placeholder: "Select a Time Range",
      filter_by: "Filter By",
      filter_by_1: "Group",
      filter_by_2: "Asset",
      // iterated fields
      dropdown_option_device_groups_all: "All Groups",
      device_groups_all: "All Groups",
      device_id_all: "All Assets",
      driver_id_all: "All Drivers",
      // status filter toggle
      device_id_status_filter_off: "All Assets",
      device_id_status_filter_on: "Active",
      device_id_all_filter_off: "Both",
      device_id_all_filter_off_descr: "Active and inactive",
      device_id_all_filter_on: "Active",
      device_id_all_filter_on_descr: "Only active assets",
      device_groups_all_filter_off: "Both",
      device_groups_all_filter_off_descr: "Active and inactive assets",
      device_groups_all_filter_on: "Active",
      device_groups_all_filter_on_descr: "Only active assets",
      // group status filter toggle labels (shown when specific group is selected)
      device_groups_status_filter_off: "All Assets",
      device_groups_status_filter_on: "Active Only",
      // dropdown fields
      alert_status: "Alert Status",
      alert_status_placeholder: "Select an Alert Status",
      asset_location_flag: "Asset Location Flag",
      asset_location_flag_placeholder: "Select an Asset Location Flag",
      distance: "Distance",
      distance_placeholder: "Select a Distance",
      digital_input: "Digital Input",
      digital_input_placeholder: "Select a Digital Input",
      exceeding_speed: "Exceeding Speed",
      exceeding_speed_placeholder: "Select a Speed",
      expire_license_flag: "Expire License Flag",
      expire_license_flag_placeholder: "Select an Expire License Flag",
      fleet_ideal_flag: "Fleet Idle Flag",
      fleet_ideal_flag_placeholder: "Select a Fleet Idle Flag",
      geozone_lookup_distance: "Geozone Lookup Distance",
      geozone_lookup_distance_placeholder: "Select a Geozone Lookup Distance",
      ignition_status: "Ignition Status",
      ignition_status_placeholder: "Select an Ignition Status",
      last_asset_location: "Last Asset Location",
      last_asset_location_placeholder: "Select a Last Asset Location",
      last_check_in: "Last Check In",
      last_check_in_placeholder: "Select a Last Check In",
      last_ignition: "Last Ignition",
      last_ignition_placeholder: "Select a Last Ignition",
      speed_over: "Speed Over",
      speed_over_placeholder: "Select a Speed",
      speeding_events: "Speeding Events",
      speeding_events_placeholder: "Select a Speeding Event",
      device_groups: "Device Groups",
      // more fields
      geozone_lookup_add_lat: "Geozone Lookup Add Lat",
      geozone_lookup_add_long: "Geozone Lookup Add Long",
      address: "Address",
      gear_selector_flag: "Gear Selector",
      gear_selector_flag_placeholder: "Select the value",
      speed_more_than_flag: "Speed More Than",
      speed_more_than_flag_placeholder: "Select the value",
      delinquent_flag: "Delinquent",
    },
    advance_filters: {
      heading: "Advance Filter",
      column: "Column",
      operator: "Operator",
      value: "Value",
      label_advance_filter: "Advance Filter",
      button_create: "Create",
      button_update: "Update",
      button_reset: "Reset",
    },
    titles: {
      type_1: "System Reports",
      type_2: "Custom Reports",
      type_3: "Shared With Me",
      type_4: "Shared With Others",
      type_5: "Custom Reports",
      type_other: "Other Reports",
      shared_by: "by",

      report_category_1: "Asset Detail",
      report_category_2: "Fleet Detail Reports",
      report_category_3: "Fleet Summary Reports",
      report_category_4: "Violation Reports",
      report_category_5: "Operator Reports",
      report_category_6: "IFTA",
      report_category_7: "Other",

      report_category_9: "Asset",
      report_category_10: "Driver",
      report_category_11: "User",

      report_category_12: "Input Reports",
      report_category_13: "Snow Plow Reports",
      report_category_14: "Maintenance Reports",
      report_category_15: "Fuel Card Integration",
      report_category_16: "Fleet Tag Reports",
      report_category_17: "Driver Reports",

      asset_report_title: "Asset Report",
      asset_report: {
        assets_near_asset: "Assets Near Asset",
        battery_health: "Battery Health",
        coolant_temprature: "Coolant Temperature",
        daily_distance_driven: "Daily Distance Driven",
        digital_input_report: "Digital Input Report",
        event_detail: "Event Detail",
        event_detail_all: "Event Detail (All Fields)",
        event_detail_speeding: "Event Detail (Speeding)",
        geozone_report: "Geozone Report",
        harsh_acceleration_report: "Harsh Acceleration Report",
        harsh_braking_report: "Harsh Braking Report",
        idle_report: "Idle Report",
      },

      driver_details_report_title: "Driver Details Report",
      driver_details_report: {
        alert_by_status: "Alert By Status",
        asset_alert_detail: "Asset Alert Detail",
      },
      group_summary_report_title: "Group Summary Report",
      group_summary_report: {
        assets_near_categorized_geozone_groups:
          "Assets Near Categorized Geozone Groups",
        assets_near_geozone: "Assets Near Geozone",
      },
      asset_performance_report_title: "Asset Performance Report",
      asset_performance_report: {
        exceeding_posted_speed: "Exceeding Posted Speed",
        speeds_over: "Speeds Over",
      },
      driver_performance_report_title: "Driver Performance Report",
      driver_performance_report: {
        driver_events: "Driver Events",
        driver_behaviour_report: "Driver Behaviour Report",
      },
      ifta_detail_report_title: "IFTA Detail Report",
      ifta_detail_report: {
        state_border_crossing_summary: "State Border Crossing Summary",
        state_mileage_summary: "State Mileage Summary",
        intra_state_mileage_summary: "Intra State Mileage Summary",
      },
    },
    toast: {
      download_success: "Report downloaded successfully",
      download_error: "Report download failed",
      delete_success: "Report deleted successfully",
      delete_error: "Report deletion failed",
    },

    columnCalculations: {
      heading: "Calculations",
      average: "Average",
      sum: "Sum",
      multiply: "Multiply",
      count: "Count",
      min: "Min",
      max: "Max",

      sub_heading: "Factor",
    },

    columnFilters: {
      search_placeholder: "Search",
      select_range: "Select Range",

      apply_condition: "Apply Condition",

      filterOutputType: {
        enum1: "Text Filter",
        enum2: "Date/Time Filter",
        enum3: "Date Filter",
        enum4: "Time Filter",
        enum6: "Number Filter",
        enum7: "Speed Filters",
        enum8: "Distance Filter", // KM_TO_DISTANCE_UNITS // 0-MILES(MILES), 1-KM(KM), 2-NAUTICAL MILES(NAUTICAL MILES)
        enum9: "Distance Filter", // M_TO_DISTANCE_UNITS // 0-MILES(MILES), 1-KM(KM), 2-NAUTICAL MILES(NAUTICAL MILES)
        enum10: "Volume Filter", // L_TO_VOLUME_UNITS // 0-GALLONS(US_GALLONS), 1-LITERS(LITERS), 2-IMPERIAL GALLONS(UK_GALLONS), 3-FT^3(CUBIC_FEET)
        enum11: "KPL Filter", // KPL_ECONOMY_UNITS // 0-MPG(MPG), 1-KM/L(KPL), 2-KPG(KPG), 3-L/100KM(LP100KM)
        enum12: "Pressure Filter", // KPA_TO_PRESSURE_UNITS // 0-kPa(KPA), 1-psi(PSI), 2-mmHg(MMHG), 3-bar(BAR)
        enum13: "Temperature Filter", // C_TO_TEMPERATURE_UNITS // 0-Fahrenheit(F), 1-Celsius(C)
        enum14: "Time Filter", // SEC_TO_HOURS
        enum15: "Time Filter", // SEC_TO_HH_MM_SS
        enum53: "Date Filter", // GREGORIAN_DATE
        enum54: "Status Filter", // ACTIVE_INACTIVE_DROPDOWN
        enum55: "AUDIT_CHANGE_TYPE", // AUDIT_CHANGE_TYPE
        enum56: "METER_TO_FEET", // METER_TO_FEET
      },
      total_items: "{{count}} items",
      x_of_y_selected: "Selected {{x}} of {{y}} items",

      // modify with caution - keys being used from enum REPORT_FILTER_OPERATOR_TYPES
      filterOptions: {
        // text
        LIKE: "Contains",
        NOT_LIKE: "Does not contain",
        EQUAL: "Equals",

        // date / time
        BEFORE: "Before",
        AFTER: "After",
        BETWEEN: "Between",

        // number
        NOT_EQUAL: "Does not equal",
        GREATER_THAN: "Greater than",
        GREATER_THAN_EQUAL: "Greater than or equal to",
        LESS_THAN: "Less than",
        LESS_THAN_EQUAL: "Less than or equal to",

        // in / not in
        IN: "In",
        NOT_IN: "Not in",
      },
    },

    too_many_columns: "too many columns",
    pdf_unavailable_too_many_columns:
      "PDF cannot be generated as there are too many columns.",

    reset_sorting: "Reset Sorting",
    column_header_title_reset_sorting: "Click to reset sorting",
    column_header_title_ascending_order: "Click to sort in ascending order",
    column_header_title_descending_order: "Click to sort in descending order",

    label_device_id: "Asset(s)",
    label_driver_id: "Driver(s)",
    label_geozone_id: "Geozone(s)",
    label_device_groups: "Group(s)",

    label_date_range: "Date Range",
    label_time_range_1: "Previous Day",
    label_time_range_2: "Last 7 Days",
    label_time_range_3: "Previous Week",
    label_time_range_4: "Last 30 Days",
    label_time_range_5: "Previous Month",

    label_vehicles: "Assets",
    label_drivers: "Drivers",
    plus_n_others_1: "+{{n}} other",
    plus_n_others: "+{{n}} others",
    options_filter: {
      heading: "Selection Filter",
      update_button: "Update Report",
    },
    vehicleReports: {
      heading: "Asset Reports",
      battery_health: "Battery Health",
      coolant_temprature: "Coolant Temperature",
      daily_distance_driven: "Daily Distance Driven",
      digital_input_report: "Digital Input Report",
      event_detail: "Event Detail",
      event_detail_all: "Event Detail (All Fields)",
      event_detail_speeding: "Event Detail (Speeding)",
      geozone_report: "Geozone Report",
      harsh_acceleration_report: "Harsh Acceleration Report",
      harsh_braking_report: "Harsh Braking Report",
      idle_report: "Idle Report",
      maintainance_history: "Maintenance History",
      snow_plows_details: "Snow Plow Details",
      temprature_monitor: "Temperature Monitor",
      select_vehicle: "Select an Asset",
      time_period: "Time Period",
      timezone: "Timezone",
      report: "Report",
    },
    duplicateReport: {
      heading: "Edit Report",
      sub_heading: "You can’t edit a System Report",
      sub_heading_text:
        "By proceeding you will be creating a custom report of the system report.",
      report_name: "Report Name",
      report_name_placeholder: "Please type the report name",
      toast: {
        duplcation_failed:
          "Failed to clone report. Please check the information that you have entered.",
      },
    },
    shareReportInternally: {
      heading: "Share Internally",
      all_users: "All Users",
      roles: "Roles",
      select_users: "Select Users",
      select_role_to_add: "Select Role to Add",
      select_roles: "Select Roles",
      select_user_to_add: "Select Users to Add",
      user_selector_no_options: "No matching users found",
      toast: {
        create_success: "Report shared successfully",
        create_failed: "Report sharing failed",
      },
    },
    shareViaEmail: {
      heading: "Share Via Email",
      heading_edit: "Edit Share Preferences",
      html: "HTML",
      xls: "XLS",
      csv: "CSV",
      pdf: "PDF",
      send_automatically: "Send Automatically",
      hourly: "Hourly",
      daily: "Daily",
      weekly: "Weekly",
      monthly: "Monthly",
      bi_monthly: "Bi-Monthly",
      delay_time: "Time of the Day",
      day_of_week: "Day of the Week",
      day_of_month: "Day of the Month",
      day_of_month2: "2nd Day of the Month",
      select_a_day: "Select a Day",
      add_email_to_add: "Add Email to Add",
      toast: {
        create_success: "Report shared successfully",
        create_failed: "Report sharing failed",
        reports_will_be_shared_soon:
          "Report will be delivered ASAP when the summaries are completed",
      },
    },
    copyReport: {
      modify_copy_report: "Modify/Copy Report",
      continue_edit: "Continue to Edit",
      report_use:
        "This report is being used for a Dashboard Widget. You can edit this report or make a copy of it",
      rename_report: "Rename Report",
      report_name: "Report Name",
      copy_created: "Copy Created",
    },
    shareReport: {
      filters: {
        all: "All",
        pdf: "PDF",
        xls: "XLS",
        csv: "CSV",
      },
      shared_with: "Shared with",
      share: "Share",
      search: "Search for email",
    },
    customizeReport: {
      heading: "Customize",
      report_name: "Report Name",
      sub_heading: "Variables",
      sub_heading_text:
        "Choose the variable/KPIs you wish to Add or Remove from you report",
      available: "Available",
      applied: "Applied",
      search_placeholder: "Search here...",
    },
    customReport: {
      use_custom_report: "Use Custom Report - Create Tile",
      use_custom_report_edit: "Use Custom Report - Edit Tile",
      sample_custom_report: "Sample Custom Report Name",
      cancel: "Cancel",
      preview: "Preview",
      publish: "Publish",
      publish_edit: "Update",
      variables: "Variables",
      details: "Details",
      details_section: {
        graph_title: "Graph Title",
        min_char: "Min 15 Characters (Type)",
        calculation: "Calculation",
        group_by: "Group By/Rows (X-Axis)",
        select: "Select",
        sub_group_by: "Sub Group By (Legend)",
        y_axis: "Y-Axis",
      },
      fill_details: "Fill in the details to see the preview",
      preview_ready_line1: "Preview is ready.",
      preview_ready_line2: "Please click on the preview button.",
    },
    table: {
      // TODO: temporarily added
      sn: "Sr.No.",
      device_description: "Device Description",
      event_date: "Event Date",
      event_time: "Event Time",
      status_desc: "Status",
      geo_point: "Geozone Point",
      address: "Address",
      speed_with_heading: "Speed (Heading)",
      vbatteryvolts: "Battery Volts",
    },
    addNewReport: {
      heading_edit: "Edit Report",
      heading_add: "New Report",
      report_name: "Report Name",
      report_for: "Report For",
      asset: "Asset",
      group: "Group",
      driver: "Driver",
      sub_heading: "Variables",
      sub_heading_text:
        "Choose the variable/KPIs you wish to Add or Remove from you report",
      available: "Available",
      applied: "Applied",
      search_placeholder: "Search here...",
      save_and_create: "Continue to Report Filters",
      save_and_update: "Save & Update",
      categories: "Categories",
      select_category: "Select Category",
      validation: {
        name_category: "Please enter/select values for fields marked in red",
        no_fields_found:
          "No fields are available for the selected category. Please select another category.",
        category_fields_error:
          "The system could not find the necessary configuration for the selected category. Please select another category.",
      },
      toast: {
        select_fields: "Please select and add fields to proceed",
        create_failed:
          "Failed to create report. Please check the information that you have entered.",
      },
    },
    createCustomReport: {
      formFields: {
        report_name: "Report Name",
        report_name_placeholder: "Please type the report name",
      },
      step1: {
        heading: "Custom Report",
        sub_heading: "Please select the report category",
      },
      step2: {
        heading: "Custom Report",
        heading_modify: "Edit Report",
        heading_copy: 'Make a copy of "{{name}}"', //"New Custom Report (copying \"{{name}}\")", // "Create a copy of \"{{name}}\"",
        sub_heading: "Select Columns",
        description:
          "Add/Remove the selection of your columns. See the information that is most relevant to your business",
        available_w_count: "Available ({{count}})",
        added_w_count: "Added ({{count}})",
        search_placeholder: "Search here...",
        save_and_continue: "Save & Continue",
        modify_report: "Update Report",
        create_copy: "Create Copy",
        unique_name_error:
          "Another report with the same name already exists. Please enter a different name",
      },
      reportOptions: {
        heading: "New Report",
        // disabled below as following translations are used from reportOptions key
        // sub_heading: "Please select the filters for the report",
        // no_filters_continue_message: "All good! Please click on the button below to proceed",
      },
    },
    reportTakingLonger: {
      heading: "The report taking longer than expected",
      description:
        "This may be due to the large amount of data being processed. We recommend that you download the report using the options below:",
    },
    reportError: {
      heading: "The report failed to generate",
      description:
        "Please use the options below to get the report emailed to your inbox:",
    },
    create_button: "Create Report",
    update_button: "Update Report",
    make_copy_button: "Make a Copy",
    create_custom_button: "Create Custom Report",
    group_by_column_locked: "Locked - Report is grouped by this column",
    drag_to_group_by_column:
      "Drag and drop this column to the grouping placeholders above",
    grand_total: "Grand Total",
  },
  camera: {
    heading: "Camera",
    menuItems: {
      video_history: "Video History",
      configuration: "Configuration",
      management: "Management",
    },
    dashboard: {
      maps: {
        receiving_data: "Receiving Data",
      },
      summary: {
        trip_summary: "Trip Summary",
        total_trips: "Total Trips",
        driving_distance_miles: "Driving Distance (miles)",
        driving_distance_nm: "Driving Distance (nm)",
        driving_distance_kms: "Driving Distance (km)",
        driving_time: "Driving Time (hrs)",
      },
      highlight: {},
      history: {
        events: {
          download_heading: "Download Event Video",
          download_sub_heading:
            "Are you sure you want to download the event video?",
          comments: {
            heading: "Event Comments",
            no_comments_yet: "No comments yet",
            input_placeholder: "Please enter a comment",
            at_date_by_name: "{{at}} by {{name}}",
          },
        },
      },
      management: {
        media: "Media",
        auto_upload: "Auto Upload to Portal:",
        choose_upload_data:
          "Choose what kind of data to auto upload to Events for reviewing if the event is triggered.",
        minor: "Minor",
        moderate: "Moderate",
        severe: "Severe",
        cameras: {
          widget_title: "Fleet Highlight",
          results: "Results",
          collapse: "Collapse",
          expand: "Expand",
          expiry: "Expires in {{days}} days",
          expired: "Expired",
          search_placeholder_camera: "Search...",
          link_asset: "Link Asset",
          voice_call: "Voice Call",
          live_view: "Live View",
          call_logs: "Call Logs",
          configuration: "Configuration",
          camera_id: "Camera ID",
          search_placeholder: "Search Asset ID, VIN or License Plate",
          search_asset_to_link: "Search Asset to Link*",
          select_status_name: "Status",
          select_status_placeholder: "All Statuses",
          select_event_name: "Event",
          select_event_placeholder: "All Events",
          select_event_no_item: "No events found.",
          select_duration: "Duration",
          select_duration_option_text: "Last {{n}} days",
          select_model_name: "Model",
          select_model_placeholder: "All Models",
          driver_id_placeholder: "All drivers",
          driver_id_no_item: "No drivers found.",
          clear: "Clear",
          online: "Online",
          offline: "Offline",
          live: "Live",
          standby: "Standby",
          not_initiated: "Not Initiated",
          not_reporting: "Not Reporting",
          configure: "Mass Configure",
          from: "From",
          to: "To",
          no_video_available: "No Video Available",
          duration: "Duration",
          asset_id: "Asset ID",
          description: "Description",
          retrieve_time: "Retrieve Time",
          retrieved_by: "Retrieved By",
          retrieval_details: "Retrieval Details",
          video_details: "Video Details",
          retrieval_information: "Retrieval Information",
          download: "Download",
          retrieve_video: "Retrieve Video",
          play_video: "Play Video",
          pause_video: "Pause Video",
          comments: "Comments",
          live_feed_info:
            "Each live view session is limited to a {{seconds}} seconds period to avoid excessive data usage.",
          camera_details: {
            tabs: {
              overview: {
                overview: "Overview",
                serial_num: "Serial Number",
                model: "Model",
                imei: "IMEI",
                signal: "Signal",
                location_fun: "Location function",
                sensor_event_detection: "Sensor Event detection",
                miai: "MiAi",
                cameras: "Camera(s)",
                storage_issue: "Footage Storage issue",
                satellite_in_use: "GPS signal and Satellites in use *",
                gps_warning:
                  "No GPS signal.\nPlease note that if the device does not have a clear view of the sky, it will not be able to provide the correct position.",
                last_location: "Last Known Location *",
                lte_signal: "LTE Signal",
                device_health_check: "Device Health Check",
                last_diagnose: "Last Diagnose",
                diagnose_now: "Diagnose Now",
                diagnose_heading: "Stop Recording and Reboot Device?",
                diagnose_sub_heading:
                  "To continue, the device will stop recording and reboot for running the diagnosis. Make sure the fleet knows the consequence of stop recording before you continue to run the diagnosis.",
                stop_reboot: "Yes, stop and reboot",
                wakeup_device: "Wake Up Device?",
                wakeup_msg:
                  "The device is currently suspended, waking it up will consume more power from the vehicle battery.",
                wakeup_submit: "Yes, wake up",
              },
              sim: {
                heading: "Camera Information",
                icc_history: "ICCID History",
              },
              app: {
                heading: "App Information",
                first_connected_timestamp: "First Connected Timestamp",
                last_connected_timestamp: "Last Connected Timestamp",
                last_app_launch_timestamp: "Last App Launch Timestamp",
                last_data_upload_failure: "Last Data Upload Failure",
                last_app_crash_timestamp: "Last App Crash Timestamp",
                data_usage: "Data Usage",
                lte_download: "LTE Download",
                lte_upload: "LTE Upload",
              },
              health: {
                embedded_camera: "Embedded Camera",
                type: "Type",
                camera_health: "Camera Health",
                "adas/dms_ai_health": "ADAS/DMS AI Health",
                inward: "Inward",
                outward: "Outward",
                healthy: "Healthy",
                adas: "ADAS",
                dms: "DMS",
                auxiliary_camera: "Auxiliary Camera",
                mounting_information: "Mounting Information",
                current_mounting: "Current Mounting",
                see_image: "See Image",
                mounting_height: "Camera Height (in cm)",
                in_cabin_camera_location: "In-Cabin Camera Location",
                driver_side_in_cabin: "Driver Side In-Cabin",
                where_is_the_in_cabin_camera: "Where is the In-Cabin Camera?",
              },
              software: {
                software_information: "Software Information",
                camera_app_version: "Camera App Version",
                camera_ai_version: "Camera AI Version",
                mobility_maps_function_version:
                  "Mobility Maps Function Version",
                detail_map: "Detail Map",
                poi_map: "POI Map",
                poi_bin: "POI Bin",
                region: "Region",
                version: "Version",
              },
              storage: {
                storage_information: "Storage Information",
                internal_storage: "Internal Storage",
                sd_card_1: "SD Card 1",
                sd_card_2: "SD Card 2",
                healthy: "Healthy",
                needs_attentation: "Needs Attention",
                format: "Format",
                gb_used: "GB Used",
                total: "Total",
                gb: "GB",
                format_success:
                  "The format request has been submitted. The device will be formatted once it reboots.",
                format_failed: "Format failed please try again",
                format_modal_heading: "Format SD Card",
                format_modal_sub_heading:
                  "All the stored data will be permanently deleted after formatting",
                format_modal_label:
                  "I understand that formatting this SD card, the recordings and event video stored in it will be permanently erased",
              },
            },
          },
          filter_groups: "Groups/Cameras",
          no_photo_available: "No photo available",
          cabin_camera: "Cabin Camera",
          road_facing_camera: "Road Facing Camera",
          extended_camera: "Extended Camera",
          rear_facing_camera: "Rear Facing Camera",
          split_view: "Split View",
          single_view: "Single View",
          split_view_description:
            "Split View - Road Facing and Driver Facing Camera",
          atleat_one_view_warning: "At least one option must be selected",
          export: "Export",
          csv_download_successful: "CSV Download Successful",
        },
        camera_settings: {
          heading: "Camera Settings",
          alert_preferances: "Alert Preferences",
          camera_configurations: "Camera Configurations",
          system: "System",
          video_recording: "Video Recording",
          volume: "Volume",
          speed_unit: "Speed Units",
          parking_photo: "Parking Photo",
          audio_alert: "Audio Alert",
          driver_id_login_audio_hint: "RFID Driver ID Audio Hint",
          driver_id_login_audio_hint_description: "Provides audible reminders for drivers to present their badge for identification.",
          driver_id_mode: "Driver ID Mode",
          driver_id_mode_description: "Choose how the camera reminds drivers to badge in and whether badge validation occurs at the camera.",
          driver_id_standard: "Standard",
          driver_id_enhanced: "Enhanced",
          live_view_audio_hint: "Live View Audio Hint",
          capture_settings: "Capture Settings",
          record_sound_in_cab: "Record Sound(in-cab)",
          video_snapshots: "Video Snapshots",
          set_up_camera_by_model: "Set up camera by model",
          camera_model: "Camera Model",
          fleet_vision: "Fleet Vision",
          video: "Video",
          item: "Item",
          value: "Value",
          format: "Format",
          resolution: "Resolution",
          two_camera_sku: "2 camera sku",
          four_camera_sku: "4 camera sku",
          grid: "Grid",
          single: "Single",
          side_by_side: "Side-By-Side",
          selected: "Selected",
          save_changes: "Save Changes?",
          save_changes_description:
            "Save changes you already made before you leave",
          restore_settings: "Restore Default Settings",
          restore_settings_description:
            "Are you sure you want to restore the default settings",
        },
        sensor_event_detection: {
          heading: "Sensor Event Detection",
          impact: "Impact",
          harsh_driving: "Harsh Driving",
          triggered_thresold: "Triggered Threshold",
          mph: "(mph)",
          nm: "(nm)",
          kmh: "(kph)",
          event_type: "Event Type",
          low_less_events: "Low Less Events",
          high_less_events: "High Less Events",
          sensitivity: "Sensitivity",
          event_trigger: "Event Trigger",
          event_trigger_description:
            "Set up the condition of triggering the event",
          driving_impact: "Driving Impact",
          parking_impact: "Parking Impact",
          event_recording: "Event Recording",
          event_recording_description:
            "Set up the duration of the recorded video when the event is triggered, which will be captured by the device for reviewing.",
          pre_event_video_duration_sec: "Pre event video duration(sec):",
          post_event_video_duration_sec: "Post event video duration(sec):",
          auto_upload_to_portal: "Auto Upload to portal",
          auto_upload_to_portal_description:
            "Choose what kind of data to auto upload to Events for reviewing if the event is triggered.",
          media: "Media",
          g_sensor_and_gps_data: "G-sensor & GPS data",
          video: "Video",
          on: "On",
          alerts: "Alerts",
          in_cabin_audio_alert: "In-cabin Audio Alert",
          harsh_acceleration: "Harsh Acceleration",
          harsh_braking: "Harsh Braking",
          harsh_cornering: "Harsh Cornering",
          speed: "Speed",
          speed_discrepancy: "Speed Discrepancy",
        },
        ai_event_detection: {
          heading_adas: "AI Event Detection - ADAS",
          heading_dms: "AI Event Detection - DMS",
          subheading_alladas: "ADAS Events",
          subheading_alldms: "DMS Events",
          adasEnable: "All ADAS Events",
          subheading_indadas: "Individual ADAS Events",
          subheading_inddms: "Individual DMS Events",
          adasEnable_sub: "Configure common settings for all DMS Events",
          adasEnable_trigger_title: "Configure common settings for all ADAS Events",
          dmsEnable_trigger_title: "Configure common settings for all DMS Events",

          adasEnableSubTitle: "Road-facing camera",
          adasEnableFieldTitle: "Advanced Driver Assistance System",
          adas_description:
            "Available in vehicles with devices applying the advanced or Pro Plan",
          adas_frontalEnable: "Front Collision Warning",
          adas_pedestrianCollisionEnable: "Pedestrian Collision Warning",
          adas_tailgatingEnable: "Tailgating",
          adas_laneEnable: "Lane Departure",
          adas_stopandgoEnable: "Stop and Go",
          dmsEnable: "All DMS Events",
          dmsEnableSubTitle: "In-cab camera",
          dmsEnableFieldTitle: "Driver Monitoring System",
          dms_description:
            "Available in vehicle with devices applying the Pro Plan",
          dms_fatigueEnable: "Fatigue",
          dms_seatbeltUnfastenEnable: "Seat Belt Unfastened",
          dms_distractionEnable: "Distracted",
          dms_phoneEnable: "Phone Usage",
          dms_lensCoveredEnable: "Lens Obstruction",
          dms_smokingEnable: "Smoking Detection",
          event_trigger: "Event Trigger",
          event_trigger_description:
            "Set up the condition of triggering the event",
          event_recording: "Event Recording",
          event_recording_description:
            "Set up the duration of the recorded video when the event is triggered, which will be captured by the device for reviewing.",
          pre_event_video_duration_sec: "Pre event video duration(sec):",
          post_event_video_duration_sec: "Post event video duration(sec):",
          event_debounce: "Event debounce timer(sec):",
          alerts: "Alerts",
          in_cabin_audio_alert: "In-cabin Audio Alert",
        },
        traffic_signal_detection: {
          heading: "Traffic Signs and Signal Detection",
          heading_all: "All Traffic Signs and Signal Detection",
          heading_ind: "Individual Traffic Signs and Signal Detection",
          truckModeEnable: "Mobility Map Function",
          speedCamEnable: "Speed Camera Notification",
          rollingStopEnable: "Rolling Stop",
          railroadCrossEnable: "Railroad Crossing Notification",
          schoolZoneSpeedingEnable: "School Zone Notification",
          speed_threshold: "Speed Threshold",
          event_recording: "Event Recording",
          event_recording_description:
            "Set up the duration of the recorded video when the event is triggered, which will be captured by the device for reviewing.",
          pre_event_video_duration_sec: "Pre event video duration(sec):",
          post_event_video_duration_sec: "Post event video duration(sec):",
          alerts: "Alerts",
          in_cabin_audio_alert: "In-cabin Audio Alert",
          in_cabin_audio_alert_description:
            "Set up if play the in-cabin audio alert for the condition",
          approaching_the_traffic_and_signal:
            "Approaching the traffic sign or signal",
          violate_the_traffic_sign_or_signal:
            "Violate the traffic sign or signal",
          speedingEnable: "Speeding",
          mode: "Mode:",
          general_mode: "General Mode",
          speeding_desc:
            "According to the POI data, the device will play an in-cabin alert when the driver is overspeeding. As soon as the trip has ended, the system will calculate the overspeeding time and distance accumulated by the driver.",
        },
      },
      video_history: {
        video_playback: {
          listing_heading: "Camera List",
          search_placeholder_listing: "Search...",
          video: "Video",
          event_list: "Event List",
          clear: "Clear",
          event_type: "Event Type",
          time: "Time",
          timeline: "Timeline",
          video_length: "Video Length",
        },
        file_retrieval: {
          deleteFile: {
            heading: "Are you sure you want to delete this file?",
            sub_heading: "This will permanently delete file from storage",
            delete_confirm: "Yes, Delete it",
            success_msg: "SD Card file deleted successfully",
            error_msg: "An error occured while deleting file",
          },
        },
      },
    },
    groupCameraSelector: {
      heading: "Group Selector",
      heading_cameras: "Camera Selector",
      sub_heading_group: "Please select the groups you wish to view.",
      sub_heading_camera: "Please select the cameras you wish to view.",
      atleast_one_group: "Please select at least one group.",
      atleast_one_camera: "Please select at least one camera.",
      camera_configuration: "Camera Configurations",
      sub_heading_camera_configuration:
        "Select the camera(s) you want to configure. Any changes made will apply to all selected cameras",
    },
    modals: {
      liveviewContinue: {
        heading: "Continue watching?",
        description_line1:
          "Live View sessions are limited to {{seconds}} seconds.",
        description_line2:
          "Please click on the continue button to start another Live View session with the device {{device}}.",
        button_continue: "Continue Live View",
      },
    },
  },
  previous: "Previous",
  save_and_next: "Save & Next",
  leave_anyway: "Leave Anyway",
  restore_to_default: "Restore to Default",
  change: "Change",
  generate: "Generate",
  duplicate: "Clone",
  download: "Download",
  share: "Share",
  customize: "Customize",
  vehicleAlerts: {
    heading: "Asset Alerts",
    listing_heading: "Asset Alert Listing",
    search_placeholder: "Search...",
    detailsPage: {
      heading: "Specific Asset Alert View",
      search_placeholder: "Search assets here...",
      listing_heading: "Assets",
    },
  },
  buzzerAlerts: {
    heading: "Panic Alerts",
    listing_heading: "Panic Alert Listing",
    search_placeholder: "Search...",
    view_map: "View Map",
    view_map_not_available: "Location not available",
    actions: {
      cancel: "Cancel",
      label_pending: "Pending",
      label_inprogress: "In Progress",
      label_resolved: "Resolved",
      in_progress: "Mark In Progress",
      pending: "Pending",
      resolved: "Mark Resolved",
    },
    map: {
      heading: "Panic Alert",
    },
  },
  dualListbox: {
    add_all: "Add All",
    add_all_on_this_page: "Add All From This Page",
    remove_all: "Remove All",
    add_selected: "Add Selected",
    remove_selected: "Remove Selected",
    active: "Active",
    inactive: "Inactive",
    items_loading: "Items are loading...",
    all_items_added: "All items have been added.",
    all_page_items_added: "All items on the page have been added.",
    all_page_items_added_line2: "To view more items, click on next page below.",
  },
  add: "Add",
  manageRuleAlert: {
    heading: "Manage Rule/Alert",
    sub_heading:
      "Turn alerts on and off and add, delete, or edit notification email addresses and phone numbers.",
    add_new: "Add New Rule",
    listing_heading: "Rule Listing",
    search_placeholder: "Search asset here...",
    create_new: {
      heading: "Add New Rule",
      sub_heading: "Please provide the information below to create a New Rule",
      ruleid: "Rule ID",
      ruleid_placeholder: "Please provide an ID",
      submit_button: "Create New Rule",
      toast: {
        create_failed:
          "Failed to create rule. Please check the information that you have entered.",
        create_success: "Rule has been created successfully.",
      },
    },
    detailsPage: {
      heading: "Specific Rule View",
      sub_heading:
        "Turn alerts on and off and add, delete, or edit notification email addresses and phone numbers.",
      listing_heading: "Rules",
      search_placeholder: "Search user here...",
      accord_general_details: "Details",
      accord_general_details_form: {
        ruleid: "Rule ID",
        system_rule: "System Rule Criteria",
        selector: "Rule Selector",
        define_value: "Define Value",
        cron_rule: "Rule Frequency",
        is_active: "Active",
        frequency: "Frequency",
        description: "Description",
        minimum_interval: "Minimum Interval",
        minimum_interval_subtitle: "in seconds",
        interval_reset: "Interval Reset",
        predefined_actions: "Predefined Actions",
        trigger_actions: "Trigger Actions",
        notify_via: "Notify Via",
        is_email_sms: "Email/SMS",
        is_save_alert: "Save/Alert",
        is_queue: "Queue",
        notifications: "Notifications",
        alerts: "Alerts",
        notification_email: "Notification Email",
        notification_phone: "Notification Phone",
        add_email_button: "Add Email",
        add_email_title: "Enter Email to Add",
        add_email_input_placeholder: "Enter the email here...",
        add_phone_button: "Add Phone",
        add_phone_title: "Enter Phone Number to Add",
        add_phone_input_placeholder: "Enter the phone number here...",
      },
      accord_advance_details: "Message Structure",
      accord_advance_details_form: {
        notification_variables: "Notification Variables",
        email_subject: "Email Subject",
        email_message: "Email Message",
        sms_message: "SMS Message",
      },
      accord_status_code_selection_details: "Asset/Group Selection",
      accord_status_code_selection_details_form: {
        assets: "Assets",
        groups: "Groups",
        status_code: "Status Code",
        assign_to: "Assign to",
      },
      toast: {
        rule_not_found: "The requested rule was not found.",
        rule_deleted: "Rule has been deleted successfully",
        deletion_failed: "Failed to delete rule",
        rule_updated: "Rule has been updated successfully",
        updation_failed: "Failed to update rule",
      },
    },
  },
  userManualSection: {
    heading: "User Manual",
  },
  helpSection: {
    heading: "Help",
    faqs: "FAQs",
    documents: "Documents",
    training_videos: "Training Videos",
    click_video_to_play: "Click on the video to start playing",
    total_duration: "Total Duration: {{duration}} min",
    no_results_found: "No results found",
    main_page_heading1: "How can we assist you today?",
    main_page_heading2:
      "Need Assistance? Find everything you need to make the most of our software",
  },
  chatSection: {
    heading: "Messages/Chat",
    search_placeholder: "Search for users...",
    no_users_found: "No users found",
    no_channels_found: "You have no chat history",
    members_w_count: "Members: {{count}}",
    view_details: "View Details",
    group_members: "Group Members",
    chat: "Chat",
    sms: "SMS",
    message_input_placeholder: "Type your message here...",
    message_input_placeholder_uploading: "Uploading...",
    file: "File",
    image: "Image",
    shared_a_file: "Shared a file",
    shared_an_image: "Shared an image",
    image_click_to_download: "Click to download",
    create_new: {
      heading: "New Group Chat",
      channel_name: "Channel Name",
      channel_name_placeholder: "Please type the channel name",
      select_users: "Select Users",
      select_user_to_add: "Select Users to Add",
      user_selector_no_options: "No matching users found",
      submit_button: "Create",
      toast: {
        create_failed:
          "Failed to create group chat. Please check the information that you have entered.",
        create_success: "Group chat has been created successfully.",
      },
    },
  },
  smsSection: {
    message_input_placeholder: "Type your message here...",
    no_permission_placeholder: "You don't have permissions to send SMS",
    create_new: {
      heading: "New SMS",
      select_user_to_add: "Select Users to Add",
      select_user_to_add_placeholder: "Type to search user...",
      user_selector_no_options: "No matching users found",
      sms_message: "Message",
      sms_message_placeholder: "Type your message here...",
      submit_button: "Send SMS",
      toast: {
        send_failed:
          "Failed to send SMS. Please check the information that you have entered.",
        send_success: "SMS has been sent successfully.",
      },
    },
  },
  fatalErrors: {
    pubnubChatError: {
      heading: "Failed to initialize messaging.",
      description:
        "Please make sure that you are logged in and have proper access to the messaging section.",
    },
    singleReportTakingLonger: {
      heading: "This report generation is taking longer than expected.",
      description:
        'This may be due to the large amount of data being processed. We recommend you to use the "Download" option to get the report emailed to your inbox.',
    },
    singleReportError: {
      heading: "This report failed to generate.",
      description:
        'We recommend you to use the "Download" option to get the report emailed to your inbox.',
    },
    duplicateReportQuery: {
      heading: "This report is already running.",
      description:
        "Please wait for it to finish before requesting it again.",
    },
  },
  cameraAdmin: {
    management: {
      parking_photo: {
        photo: "Parking Photo",
      },
    },
  },
};
